<template>
    <div class="h-full bg-gray-100">
        <div class="relative ">
            <!-- Pasek -->
            <div class="absolute top-0 left-0 w-full text-white h-16 flex items-center justify-between px-4 ">
                <div class="grid grid-cols-3 w-full">
                    <div class="col-span-1 z-[9]">
                        <button :disabled="!loadPreviousPossible"
                                class="p-2 border border-2 border-gray-400 rounded-md mr-2 bg-white red"
                                @click=loadPrevious()>
                            <img :src="loadPreviousPossible ? '/icons/undo.svg' : '/icons/undo-gray.svg'" alt="Undo">
                        </button>
                        <button :disabled="!loadNextPossible"
                                class="p-2 border border-2 border-gray-400 rounded-md bg-white" @click=loadNext()>
                            <img :src="loadNextPossible ? '/icons/redo.svg' : '/icons/redo-gray.svg'" alt="Undo">
                        </button>
                    </div>
                    <div class="col-span-1">

                    </div>
                    <div class="col-span-1 z-[11] ml-auto flex">
                        <!-- Minus -->
                        <button
                            class="p-2 bg-white border border-2 border-gray-400 rounded-md flex items-center justify-center border-r-0 rounded-br-none rounded-tr-none"
                            @click=minusChangeStageScale()
                        >
                            <img src="/icons/minus.svg" alt="Minus" class="w-5 h-5">
                        </button>

                        <!-- Input -->
                        <input
                            type="text"
                            :value="formattedScale"
                            :readonly="true"
                            class="text-gray-500  w-20 text-center h-10 px-0 border-2 border-gray-400"
                        />
                        <!--                        @input="scaleUpdateValue($event.target.value)"-->

                        <!-- Plus -->
                        <button
                            class="p-2  bg-white border border-2 border-gray-400 rounded-md flex items-center justify-center border-l-0 rounded-tl-none rounded-bl-none"
                            @click=plusChangeStageScale()
                        >
                            <img src="/icons/plus.svg" alt="Plus" class="w-5 h-5">
                        </button>
                    </div>
                </div>
            </div>


            <div class="flex justify-center items-center h-screen ">
                <div class="configurator">
                    <v-stage ref="stage" :config="stageConfig" @click="handleStageClick"
                             :class="textValidation ? 'border-2 border-red-500' : ''">
                        <v-layer ref="layer" :config="layerConfig">
                            <v-image ref="image" :config="imageConfig"/>
                            <v-rect
                                ref="shape"
                                :config="rectangleConfig"
                            />

                            <v-circle
                                ref="shape"
                                :config="circleConfig"
                            />

                            <v-shape
                                ref="shape"
                                :sceneFunc="drawCustomShape"
                                :config="customShapeConfig"
                            />
                            <v-rect
                                ref="border"
                                :config="borderConfig"
                            />
                            <v-circle :config="pointConfig"/>
                            <v-rect :config="debugRotatedRectConfig"/>
                            <v-rect :config="debugUnrotatedRectConfig"/>
                            <v-rect :config="debugBorderRectConfig"/>
                            <v-line :config="debugRotatedRectPointsConfig"/>
                            <v-image
                                ref="logo"
                                :config="logoConfig"
                                @click="selectElement('logo')"
                                @dragmove="handleDragMove"
                                @dragend="handleDragEnd"
                                @transformend="handleTransformEnd"

                            />


                            <v-text
                                ref="text"
                                :config="textConfig"
                                @click="selectElement('text')"
                                @dragmove="handleDragMove"
                                @dragend="handleDragEnd"
                                @transformend="handleTransformEnd"
                            />


                            <v-transformer
                                ref="transformer"
                                :config="transformerConfig"
                                :boundBoxFunc="boundBoxCallback"
                                :anchorSize="7"
                                :enabledAnchors="['top-left', 'top-right', 'bottom-left', 'bottom-right']"
                            />
                        </v-layer>
                    </v-stage>
                    <div
                        class="flex justify-center items-center"
                        :class="selectedNode ? '' : 'opacity-0'"
                    >
                        <div class="fast-actions flex space-x-4 bg-white border border-2 border-gray-400 rounded-md">
                            <div class="rounded-md">
                                <button
                                    class="p-2 bg-white flex items-center justify-center rounded-md"
                                    @click="fastAction('delete')"
                                >
                                    <img src="/icons/trash.svg" alt="Plus" class="w-5 h-5">
                                </button>
                            </div>
                            <div>
                                <button
                                    class="p-2 bg-white flex items-center justify-center"
                                    @click="fastAction('left')"
                                >
                                    <img src="/icons/left.svg" alt="Plus" class="w-5 h-5">
                                </button>
                            </div>
                            <div>
                                <button
                                    class="p-2 bg-white flex items-center justify-center"
                                    @click="fastAction('right')"
                                >
                                    <img src="/icons/right.svg" alt="Plus" class="w-5 h-5">
                                </button>
                            </div>
                            <div>
                                <button
                                    class="p-2 bg-white flex items-center justify-center"
                                    @click="fastAction('top')"
                                >
                                    <img src="/icons/top.svg" alt="Plus" class="w-5 h-5">
                                </button>
                            </div>
                            <div>
                                <button
                                    class="p-2 bg-white flex items-center justify-center"
                                    @click="fastAction('bottom')"
                                >
                                    <img src="/icons/bottom.svg" alt="Plus" class="w-5 h-5">
                                </button>
                            </div>
                            <div>
                                <button
                                    class="p-2 bg-white flex items-center justify-center"
                                    @click="fastAction('center')"
                                >
                                    <img src="/icons/center.svg" alt="Plus" class="w-5 h-5">
                                </button>
                            </div>
                            <div>
                                <button
                                    class="p-2 bg-white flex items-center justify-center"
                                    @click="fastAction('middle')"
                                >
                                    <img src="/icons/middle.svg" alt="Plus" class="w-5 h-5">
                                </button>
                            </div>
                            <div class="rounded-md">
                                <button
                                    class="p-2 bg-white flex items-center justify-center rounded-md"
                                    @click="fastAction('crop')"
                                >
                                    <img src="/icons/crop.svg" alt="Plus" class="w-5 h-5">
                                </button>
                            </div>


                        </div>
                    </div>
                </div>


            </div>

            <div class="absolute bottom-1 left-0 w-full py-4"
                 :class="confirmed && !editAfterSave ? 'z-[99] ':''"
                 v-if="printPlace && product && variants && variants.length > 1">
                <div class="text-center">
                    <h2 class="text-md font-semibold text-gray-600 mb-2">{{ selectedColorsTitle }}</h2>
                    <div class="flex justify-center space-x-2">
                        <template v-for="variant in variants">
                            <div
                                class="w-8 h-8 rounded-full border-2 border-gray-400 flex items-center justify-center"
                                :class="'product-variant--color_code_'+variant.color_code"
                                @click="changeVariant(variant.product_erp_code)">
                                <img v-if="variant.product_erp_code === pickedVariant"
                                     src="/icons/check.svg" alt="Check" class="w-5 h-5">
                            </div>
                        </template>
                    </div>
                </div>
            </div>

        </div>

        <Modal
            v-model="cropModalOpen"
            :title="'Przytnij obraz'"
            :size="'md'"
        >
            <Crop
                :image="cropFileUrl"
                @crop:logo="cropLogo"
                @modal:close="cropModalOpen=false"
            >
            </Crop>


        </Modal>
    </div>

</template>


<script>
import {defineAsyncComponent} from 'vue';
import FileGallery from "./upload/FileGallery.vue";
import Modal from "./Modal.vue";
import {eventBus} from "../eventBus";
import {$t} from '../composables/useTranslation.js';
import {getPrintMethodArea} from '../config/printMethodAreas.js';
import {loadVisualizerFont, loadVisualizerFonts, quoteFontFamily} from '../utils/visualizerFonts';

// Lazy load Crop to reduce initial bundle size (vue-advanced-cropper is ~500KB)
const Crop = defineAsyncComponent(() => import('./Crop.vue'));

export default {
    name: "Configurator",
    components: {Crop, Modal, FileGallery},
    props: {
        uuid: {
            type: String,
            required: false
        },
        imageData: {
            type: Object,
            required: false
        },
        textSettings: {
            type: Object,
            required: false
        },
        textContent: {
            type: String,
            required: false
        },
        imageSettings: {
            type: Object,
            required: false
        },
        colors: {
            type: Object,
            required: false
        },
        colorsFile: {
            type: String,
            required: false
        },
        downloadVisualizationTrigger: {
            type: Number,
            required: false
        },
        downloadVisualizationType: {
            type: String,
            required: false
        },
        qualityScore: {
            type: Number,
            required: false
        },
        confirmed: {
            type: Boolean,
            default: false
        },
        editAfterSave: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            changedOriginalLogo: false,
            visualizationLoaded: false,
            afterCropLogo: false,
            cropModalOpen: false,
            cropFileUrl: null,
            cropFileNameAfter: null,
            logoHistories: [],
            textHistories: [],
            currentLogoHistoryIndex: -1,
            currentTextHistoryIndex: -1,
            textOverflowError: false, // Flaga pamiętająca, że użytkownik próbował wpisać za długi tekst
            selectedNode: null,
            transformerConfig: {
                resizeEnabled: false,
                rotationEnabled: true,
                centeredScaling: true
            },
            textConfig: {
                x: -1, // Wartości zostaną nadpisane w computed
                y: -1,
                name: 'textConfig',
                text: 'Tekst w środku',
                fontSize: 16,
                fontFamily: 'Arial',
                fill: '#000000',
                align: 'center',
                verticalAlign: 'middle',
                visible: false,
                draggable: true,
                dragBoundFunc: shapeDragBoundFunc
            },
            scale: 100,
            loading: false,
            lastNodeSettings: null,
            logoConfig: {
                image: null, // Zostanie ustawione po załadowaniu obrazu
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                rotation: 0,
                name: 'logoImage',
                draggable: true,
                visible: false,
                dragBoundFunc: shapeDragBoundFunc
            },
            imageConfig: {
                image: null, // Zostanie ustawione po załadowaniu obrazu
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                name: 'backgroundImage', // Dodajemy nazwę
            },
            rectangleConfig: {
                rotation: 0,
                x: 150,
                y: 150,
                width: 200,
                height: 100,
                stroke: 'lime',
                strokeWidth: 2,
                dash: [10, 5],
                draggable: false,
                visible: false,
                name: 'gboxRectangle',
            },
            borderConfig: {
                rotation: 0,
                x: 150,
                y: 150,
                width: 200,
                height: 100,
                draggable: false,
                visible: false,
                name: 'gboxBorder',
                gboxShape: 'rect',
            },
            circleConfig: {
                x: 150,
                y: 150,
                radius: 50,
                stroke: 'lime',
                strokeWidth: 2,
                dash: [10, 5],
                draggable: false,
                name: 'gboxCircle',
                visible: false,
            },
            customShapeConfig: {
                x: 150,
                y: 150,
                width: 200,
                height: 100,
                stroke: 'lime',
                strokeWidth: 2,
                dash: [10, 5],
                draggable: false,
                name: 'gboxCustom',
                visible: false
            },
            stageConfig: {
                scaleX: 1,
                scaleY: 1,
                width: 800,  // Stały rozmiar dla testu
                height: 600,
                draggable: false,
            },
            layerConfig: {
                width: 800,  // Stały rozmiar dla testu
                height: 600,
                draggable: false,
            },
            product: null,
            visualization: null,
            fakeVisualization: null,
            printMethod: null,
            printPlace: null,
            variants: [],
            pickedVariant: null,
            extensions: [],
            currentShape: null,
            userId: null,
            pointConfig: {
                x: 0, // Zostanie obliczone
                y: 0, // Zostanie obliczone
                radius: 5, // Rozmiar punktu
                fill: 'red', // Kolor punktu
                name: 'centerPoint',
            },
            debugRotatedRectConfig: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                stroke: 'blue',
                strokeWidth: 2,
                name: 'debugRotatedRect',
                visible: false,
                draggable: false,
            },
            debugUnrotatedRectConfig: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                stroke: 'green',
                strokeWidth: 2,
                name: 'debugUnrotatedRect',
                visible: false,
                draggable: false,
            },
            debugRotatedRectPointsConfig: {
                points: [],
                stroke: 'red',
                strokeWidth: 2,
                name: 'debugRotatedRectPoints',
                visible: false,
                draggable: false,
                closed: true,
            },
            debugBorderRectConfig: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                stroke: 'purple',
                strokeWidth: 2,
                name: 'debugBorderRect',
                visible: false,
                draggable: false,
            },
            paramsNotValid: false,
            selectedColorsTitle: 'WYBRANE KOLORY PRODUKTU',
            initialStageState: null,
            lastValidText: '',
            greenboxCaptureLockCount: 0,
            greenboxCaptureStrokeSnapshot: null,
        };
    },
    computed: {
        formattedScale() {
            return `${this.scale} %`;
        },
        loadPreviousPossible() {
            if (this.selectedNode) {

                if (this.selectedNode.attrs.name === "logoImage") {
                    if (this.logoHistories[this.currentLogoHistoryIndex - 1] !== undefined) {
                        return true;
                    }
                }

                if (this.selectedNode.attrs.name === "textConfig") {
                    if (this.textHistories[this.currentTextHistoryIndex - 1] !== undefined) {
                        return true;
                    }
                }
            }

            return false;
        },
        loadNextPossible() {
            if (this.selectedNode) {
                if (this.selectedNode.attrs.name === "logoImage") {
                    if (this.logoHistories[this.currentLogoHistoryIndex + 1] !== undefined) {
                        return true;
                    }
                }

                if (this.selectedNode.attrs.name === "textConfig") {
                    if (this.textHistories[this.currentTextHistoryIndex + 1] !== undefined) {
                        return true;
                    }
                }
            }

            return false;
        },
        textValidation() {
            return eventBus.textValidation;
        }

    },
    watch: {
        imageData: {
            handler(newImageData) {
                if (Object.keys(newImageData || {}).length === 0) {
                    this.logoConfig.visible = false;
                    this.removeTransformerSelection()
                    let colors = JSON.parse(JSON.stringify(this.colors));
                    this.saveVisualization(colors)
                    return;
                }

                const logoUrl = this.resolveLogoPreviewUrl(newImageData);
                if (logoUrl) {
                    this.updateImage(logoUrl);

                    if (this.changedOriginalLogo === true) {
                        this.setImage();
                    }
                }
            },
            deep: true, // Głębokie obserwowanie obiektów
        },
        colors: {
            handler(newColors) {
                if (newColors) {
                    if (this.logoHistories[this.currentLogoHistoryIndex] !== undefined && this.logoHistories[this.currentLogoHistoryIndex].colors === null) {
                        this.logoHistories[this.currentLogoHistoryIndex].colors = JSON.parse(JSON.stringify(newColors))
                        this.addHistory('logo')
                    }
                }
            },
            deep: true, // Głębokie obserwowanie obiektów
        },
        colorsFile: {
            handler(newFile) {
                if (newFile) {
                    this.cropLogo(newFile, false)
                }
            },
        },
        textSettings: {
            handler(newSettings) {
                this.updateText(newSettings)
            },
            deep: true, // Głębokie obserwowanie obiektów
        },
        textContent: {
            handler(newSettings, oldSettings) {
                const previousText = this.textConfig.text;

                if (newSettings === previousText) {
                    this.textConfig.text = newSettings ?? '';
                    if (this.textOverflowError) {
                        this.$emit('update:text-validation', false);
                    }
                    return;
                }

                this.textConfig.text = newSettings ?? '';

                this.$nextTick(() => {
                    const fits = this.validateBoxing();

                    if (!fits) {
                        this.textOverflowError = true;
                        this.$emit('update:text-validation', false);

                        this.textConfig.text = previousText;
                        this.$emit('revert:text-content', previousText);
                    } else {
                        this.textOverflowError = false;
                        setTimeout(() => {
                            const colors = JSON.parse(JSON.stringify(this.colors));

                            this.saveVisualization(colors, true);

                        }, 500);
                    }
                });
            },
            deep: true, // Głębokie obserwowanie obiektów
        },
        imageSettings: {
            handler(newSettings) {

                this.updateImageSettings(newSettings)
            },
            deep: true, // Głębokie obserwowanie obiektów
        },
        textValidation: {
            handler(validation) {
                // if (validation) {
                //     this.rectangleConfig.stroke = 'lime';
                // } else {
                //     this.rectangleConfig.stroke = 'red';
                // }
            },
            deep: true, // Głębokie obserwowanie obiektów
        },
        downloadVisualizationTrigger: {
            handler() {
                this.runCaptureWithHiddenGreenbox(
                    () => this.downloadVisualization()
                );
            },
            deep: true, // Głębokie obserwowanie obiektów
        },
        confirmed: {
            handler(newValue, oldValue) {
                if (oldValue === false && newValue === true) {
                    this.selectedNode = null;

                    this.$nextTick(() => {
                        const transformer = this.$refs.transformer.getNode();
                        transformer.nodes([]);
                        transformer.getLayer().batchDraw();
                    });
                }
            }
        },
        printMethod() {
            this.applyGreenboxBackgroundConfig();
            this.$nextTick(() => {
                this.emitLogoAreaStatus();
            });
        }
    },
    async mounted() {
        this.fetchProduct();

        this.selectedColorsTitle = await $t('product.selected_colors', 'WYBRANE KOLORY PRODUKTU');
        this.textConfig.text = await $t('text.default_text', 'Tekst w środku');

        this.$emit('set:boundbox-validator', this.validateLogoRotation);
        this.$emit('set:boundbox-fitter', this.fitLogoToRotation);

        this.$emit('set:remove-transformer-selection', this.removeTransformerSelection);
        setTimeout(() => {
            this.addHistory('logo', true)
        }, 500);

        loadVisualizerFonts().then(() => this.redrawTextLayer());
    },
    methods: {
        shouldApplyWhiteGreenboxBackground() {
            const method = this.printMethod;
            return method === 'D' || method === 'D1' || method === 'PL';
        },
        redrawTextLayer() {
            const textNode = this.$refs.text?.getNode();
            if (textNode && typeof textNode._setTextData === 'function') {
                textNode._setTextData();
            }
            const layer = this.$refs.layer?.getNode();
            if (layer) {
                layer.batchDraw();
            }
        },
        applyGreenboxBackgroundConfig() {
            const shouldFillWhite = this.shouldApplyWhiteGreenboxBackground();
            const fill = shouldFillWhite ? '#FFFFFF' : undefined;

            this.rectangleConfig.fill = fill;
            this.circleConfig.fill = fill;
            this.customShapeConfig.fill = fill;

            this.rectangleConfig.fillEnabled = shouldFillWhite;
            this.circleConfig.fillEnabled = shouldFillWhite;
            this.customShapeConfig.fillEnabled = shouldFillWhite;
        },
        getGreenboxStrokeState() {
            return {
                rect: this.rectangleConfig.strokeWidth,
                circle: this.circleConfig.strokeWidth,
                shape: this.customShapeConfig.strokeWidth,
            };
        },
        setGreenboxStrokeState({rect, circle, shape}) {
            this.rectangleConfig.strokeWidth = rect;
            this.circleConfig.strokeWidth = circle;
            this.customShapeConfig.strokeWidth = shape;
            this.redrawGreenboxLayer();
        },
        redrawGreenboxLayer() {
            const layer = this.$refs.layer?.getNode();
            if (layer) {
                layer.batchDraw();
            }
        },
        hideGreenboxStrokeForCapture() {
            if (this.greenboxCaptureLockCount === 0) {
                this.greenboxCaptureStrokeSnapshot = this.getGreenboxStrokeState();
                this.setGreenboxStrokeState({rect: 0, circle: 0, shape: 0});
            }

            this.greenboxCaptureLockCount++;
        },
        restoreGreenboxAfterCapture() {
            if (this.greenboxCaptureLockCount <= 0) {
                return;
            }

            this.greenboxCaptureLockCount--;

            if (this.greenboxCaptureLockCount === 0 && this.greenboxCaptureStrokeSnapshot) {
                this.setGreenboxStrokeState(this.greenboxCaptureStrokeSnapshot);
                this.greenboxCaptureStrokeSnapshot = null;
            }
        },
        clearTransformerSelectionForCapture() {
            this.selectedNode = null;

            this.$nextTick(() => {
                const transformer = this.$refs.transformer?.getNode();
                if (!transformer) {
                    return;
                }

                transformer.nodes([]);
                transformer.getLayer()?.batchDraw();
            });
        },
        waitForStageReady(ms = 500) {
            return new Promise((resolve) => {
                this.$nextTick(() => {
                    setTimeout(resolve, ms);
                });
            });
        },
        async runCaptureWithHiddenGreenbox(captureFn, {delayMs = 500} = {}) {
            this.clearTransformerSelectionForCapture();
            await this.$nextTick();

            const transformer = this.$refs.transformer?.getNode();
            if (transformer) {
                transformer.nodes([]);
                transformer.getLayer()?.batchDraw();
            }

            this.hideGreenboxStrokeForCapture();

            try {
                await this.waitForStageReady(delayMs);
                await captureFn();
            } finally {
                this.restoreGreenboxAfterCapture();
            }
        },
        forceChangeOriginalLogo() {
            this.changedOriginalLogo = true;
        },
        removeTransformerSelection() {
            this.selectedNode = null;

            this.$nextTick(() => {
                const transformer = this.$refs.transformer.getNode();
                transformer.nodes([]);
                transformer.getLayer().batchDraw();
            });

        },
        selectElement(refName) {
            const ref = this.$refs[refName];
            if (!ref) {
                return;
            }
            const node = ref.getNode ? ref.getNode() : null;
            if (!node) {
                return;
            }
            this.selectedNode = node;

            // Ustawienie resizeEnabled dynamicznie na podstawie typu elementu
            const transformer = this.$refs.transformer.getNode();
            this.transformerConfig.resizeEnabled = (refName === 'logo');

            this.$nextTick(() => {
                transformer.nodes([node]);
                transformer.getLayer().batchDraw();
            });
        },
        handleStageClick(e) {
            if (e.target.attrs.name !== 'logoImage' && e.target.attrs.name !== 'textConfig') {
                this.selectedNode = null;
                this.$nextTick(() => {
                    const transformer = this.$refs.transformer.getNode();
                    transformer.nodes([]);
                    transformer.getLayer().batchDraw();
                });
            }
        },
        deg2rad(deg) {
            return (deg * Math.PI) / 180;
        },
        rad2deg(rad) {
            return rad * 180 / Math.PI;
        },
        boundBoxCallback(oldBox, newBox) {
            const rotation = this.rad2deg(newBox.rotation);
            const newBoxPoints = calculateRotatedCorners(newBox.x, newBox.y, newBox.width, newBox.height, rotation);

            const xCoords = newBoxPoints.map(p => p.x)
            const yCoords = newBoxPoints.map(p => p.y)

            const boundingBox = {
                x1: Math.min(...xCoords),
                x2: Math.max(...xCoords),
                y1: Math.min(...yCoords),
                y2: Math.max(...yCoords),
            };

            const borderNode = this.$refs.border.getNode();
            const borderRotation = borderNode.rotation();
            let borderRect = borderNode.getClientRect();
            if (borderRotation !== 0) {
                borderNode.rotation(0);
                borderRect = borderNode.getClientRect();
                borderNode.rotation(borderRotation);
            }


            if (newBox.width <= 10 || newBox.height <= 10) {
                return oldBox;
            }

            // Greenbox w kształcie koła: zezwalamy na transformację tylko, gdy wszystkie
            // narożniki przekształconego boxa nadal mieszczą się w okręgu.
            const circle = getGboxCircle(borderNode);
            if (circle) {
                return cornersInsideCircle(newBoxPoints, circle, 0) ? newBox : oldBox;
            }

            if (borderRotation !== 0) {
                // Transform new box points into the border's unrotated coordinate system
                const transformedPoints = newBoxPoints.map(point =>
                    rotatePoint(borderRect.x, borderRect.y, point.x, point.y, -borderRotation)
                );

                const tX = transformedPoints.map(p => p.x);
                const tY = transformedPoints.map(p => p.y);
                const transformedBoundingBox = {
                    x1: Math.min(...tX),
                    x2: Math.max(...tX),
                    y1: Math.min(...tY),
                    y2: Math.max(...tY),
                };

                const borderCenterX = borderRect.x + borderRect.width / 2;
                const borderCenterY = borderRect.y + borderRect.height / 2;
                const unrotatedBorderRect = {
                    x: borderCenterX - borderRect.width / 2,
                    y: borderCenterY - borderRect.height / 2,
                    width: borderRect.width,
                    height: borderRect.height
                };

                if (
                    transformedBoundingBox.x1 > unrotatedBorderRect.x &&
                    transformedBoundingBox.x2 < unrotatedBorderRect.x + unrotatedBorderRect.width &&
                    transformedBoundingBox.y1 > unrotatedBorderRect.y &&
                    transformedBoundingBox.y2 < unrotatedBorderRect.y + unrotatedBorderRect.height
                ) {
                    return newBox;
                }
            } else {
                if (boundingBox.x1 > borderRect.x
                    && boundingBox.x2 < borderRect.x + borderRect.width
                    && boundingBox.y1 > borderRect.y
                    && boundingBox.y2 < borderRect.y + borderRect.height) {
                    return newBox;
                }
            }
            // this.validateBoxing();

            return oldBox;
        },

        getClientRect(rotatedBox) {
            const {x, y, width, height, rotation} = rotatedBox;

            const getCorner = (pivotX, pivotY, diffX, diffY, angle) => {
                const distance = Math.sqrt(diffX * diffX + diffY * diffY);
                angle += Math.atan2(diffY, diffX);
                return {
                    x: pivotX + distance * Math.cos(angle),
                    y: pivotY + distance * Math.sin(angle),
                };
            };

            const rad = rotation;
            const p1 = getCorner(x, y, 0, 0, rad);
            const p2 = getCorner(x, y, width, 0, rad);
            const p3 = getCorner(x, y, width, height, rad);
            const p4 = getCorner(x, y, 0, height, rad);

            const minX = Math.min(p1.x, p2.x, p3.x, p4.x);
            const minY = Math.min(p1.y, p2.y, p3.y, p4.y);
            const maxX = Math.max(p1.x, p2.x, p3.x, p4.x);
            const maxY = Math.max(p1.y, p2.y, p3.y, p4.y);

            return {
                x: minX,
                y: minY,
                width: maxX - minX,
                height: maxY - minY,
            };
        },

        updatePointPosition() {
            // Obliczenie środka prostokąta
            const xCenter = this.borderConfig.x + this.borderConfig.width / 2;
            const yCenter = this.borderConfig.y + this.borderConfig.height / 2;

            // Aktualizacja konfiguracji punktu
            this.pointConfig.x = xCenter;
            this.pointConfig.y = yCenter;
        },
        isSvgMedia(imageData) {
            if (!imageData) {
                return false;
            }

            const mime = (imageData.mime_type || '').toLowerCase();
            if (mime.includes('svg')) {
                return true;
            }

            const fileName = imageData.file_name || imageData.name || '';
            return /\.svg(\?|#|$)/i.test(fileName);
        },
        isEngravingPrintMethod() {
            const method = this.printMethod || '';
            return method.startsWith('L') || method.startsWith('TC');
        },
        isDdcPrintMethod() {
            const method = this.printMethod || '';
            return method === 'DDC1' || method === 'DDC2' || method === 'DDC3';
        },
        applyDdcLogoBlend() {
            if (this.isDdcPrintMethod()) {
                // Corel: przezroczystość 30% + mnożenie. Biel znika, kolor papieru przyciemnia resztę.
                this.logoConfig.globalCompositeOperation = 'multiply';
                this.logoConfig.opacity = 0.7;
                return;
            }

            if (this.logoConfig.globalCompositeOperation === 'multiply') {
                this.logoConfig.globalCompositeOperation = 'source-over';
            }
        },
        deriveSvgPreviewUrl(imageData) {
            if (imageData?.svg_preview_url) {
                return imageData.svg_preview_url;
            }

            if (!this.isSvgMedia(imageData)) {
                return null;
            }

            const fileName = imageData.file_name || imageData.name || '';
            const baseName = fileName.replace(/\.[^.]+$/i, '');
            if (!baseName) {
                return null;
            }

            const sourceUrl = imageData.original_url || imageData.preview_url;
            if (!sourceUrl) {
                return null;
            }

            const collectionMatch = sourceUrl.match(/^(.*\/collections\/\d+\/)/);
            if (collectionMatch) {
                return `${collectionMatch[1]}conversions/${baseName}-svg.svg`;
            }

            return null;
        },
        resolveLogoPreviewUrl(imageData) {
            if (!imageData) {
                return null;
            }

            // Grawer: celowo przetworzona wersja (replace_all_colors / test_engrave_*.svg)
            if (this.isEngravingPrintMethod()) {
                return imageData.svg_preview_url || imageData.preview_url || imageData.original_url || null;
            }

            // SVG poza grawerem: przycięta kopia (clean_svg_background), nie surowy oryginał z marginesem
            if (this.isSvgMedia(imageData)) {
                return this.deriveSvgPreviewUrl(imageData)
                    || imageData.original_url
                    || imageData.preview_url
                    || null;
            }

            return imageData.svg_preview_url || imageData.preview_url || imageData.original_url || null;
        },
        updateImage(previewUrl, justUpdateImage = false) {
            let image = new window.Image();
            image.src = previewUrl;
            image.onload = () => {
                this.adjustImage(image, justUpdateImage);
                this.$emit(
                    'resize:logo',
                    {
                        "scale": this.printPlace.gbox_settings.scale,
                        "config": this.logoConfig
                    }
                )

                if (justUpdateImage) {
                    this.selectElement('logo')
                    this.$nextTick(() => {
                        this.fastAction('middle')
                        this.$nextTick(() => {
                            this.fastAction('center')
                        });
                    });
                } else if (this.visualizationLoaded) {
                    this.visualizationLoaded = false;
                } else {
                    this.selectElement('logo')
                    this.$nextTick(() => {
                        this.fastAction('middle')
                        this.$nextTick(() => {
                            this.fastAction('center')
                            this.$nextTick(() => {
                                setTimeout(() => {
                                    this.fastAction('center')
                                }, 500);
                            });
                        });
                    });
                }
            };

        },
        async updateText(settings) {
            if (!settings) {
                this.textConfig.visible = false;
                return;
            } else {
                this.textConfig.visible = true;
            }

            let oldFontSize = this.textConfig.fontSize;

            this.textConfig.fontFamily = settings.fontFamily;
            this.textConfig.fontSize = settings.fontSize.replace(/\D/g, "");
            this.textConfig.align = settings.textAlign;
            this.textConfig.fontWeight = settings.fontWeight;
            this.textConfig.fontStyle = settings.fontStyle + ' ' + settings.fontWeight;
            this.textConfig.textDecoration = settings.textDecoration;
            this.textConfig.fill = settings.color;

            await loadVisualizerFont(
                this.textConfig.fontFamily,
                this.textConfig.fontSize,
                this.textConfig.fontStyle
            );
            this.redrawTextLayer();

            this.selectedNode = null;
            this.$nextTick(() => {
                const transformer = this.$refs.transformer.getNode();
                transformer.nodes([]);
                transformer.getLayer().batchDraw();
            });

            this.adjustText();

            this.$nextTick(() => {
                if (oldFontSize !== this.textConfig.fontSize) {
                    const fits = this.validateBoxing();
                    if (!fits) {
                        this.textConfig.fontSize = oldFontSize;
                        this.$emit('revert:font-size', oldFontSize);
                    }
                } else {
                    this.validateBoxing();
                }
            });

            setTimeout(() => {
                const colors = JSON.parse(JSON.stringify(this.colors));

                this.saveVisualization(colors, true);

            }, 500);

        },
        getLogoVisualCenter(x, y, width, height, rotation) {
            const half = this.rotatePoint2(
                {x: width / 2, y: height / 2},
                this.deg2rad(rotation)
            );
            return {x: x + half.x, y: y + half.y};
        },
        getLogoTopLeftForCenter(centerX, centerY, width, height, rotation) {
            const half = this.rotatePoint2(
                {x: width / 2, y: height / 2},
                this.deg2rad(rotation)
            );
            return {x: centerX - half.x, y: centerY - half.y};
        },
        logoFitsGboxAtPose(width, height, x, y, rotation) {
            if (!(width > 0) || !(height > 0)) {
                return false;
            }

            const corners = calculateRotatedCorners(x, y, width, height, rotation);
            const epsilon = 0.15;

            if (this.borderConfig.gboxShape === 'circle') {
                const cx = this.borderConfig.x + this.borderConfig.width / 2;
                const cy = this.borderConfig.y + this.borderConfig.height / 2;
                const radius = Math.min(this.borderConfig.width, this.borderConfig.height) / 2;
                return corners.every(corner =>
                    Math.hypot(corner.x - cx, corner.y - cy) <= radius + epsilon
                );
            }

            const borderX = this.borderConfig.x;
            const borderY = this.borderConfig.y;
            const borderWidth = this.borderConfig.width;
            const borderHeight = this.borderConfig.height;
            const borderRotation = this.borderConfig.rotation || 0;

            const localCorners = borderRotation
                ? corners.map(point => rotatePoint(borderX, borderY, point.x, point.y, -borderRotation))
                : corners;

            const xs = localCorners.map(point => point.x);
            const ys = localCorners.map(point => point.y);

            return (
                Math.min(...xs) >= borderX - epsilon &&
                Math.max(...xs) <= borderX + borderWidth + epsilon &&
                Math.min(...ys) >= borderY - epsilon &&
                Math.max(...ys) <= borderY + borderHeight + epsilon
            );
        },
        getMaxLogoScaleForCurrentPose(width, height, centerX, centerY, rotation) {
            const fitsAtScale = (scaleFactor) => {
                const scaledWidth = width * scaleFactor;
                const scaledHeight = height * scaleFactor;
                const topLeft = this.getLogoTopLeftForCenter(
                    centerX,
                    centerY,
                    scaledWidth,
                    scaledHeight,
                    rotation
                );
                return this.logoFitsGboxAtPose(
                    scaledWidth,
                    scaledHeight,
                    topLeft.x,
                    topLeft.y,
                    rotation
                );
            };

            if (fitsAtScale(1) || this.getAabbFitScale(width, height, rotation) >= 1) {
                return 1;
            }

            let lo = 0;
            let hi = 1;
            for (let i = 0; i < 24; i++) {
                const mid = (lo + hi) / 2;
                if (fitsAtScale(mid)) {
                    lo = mid;
                } else {
                    hi = mid;
                }
            }

            return lo;
        },
        getLiveLogoRotation(...hints) {
            const fromConfig = parseFloat(this.logoConfig.rotation);
            if (Number.isFinite(fromConfig)) {
                return fromConfig;
            }

            let fromNode = NaN;
            try {
                const node = this.$refs.logo && this.$refs.logo.getNode();
                if (node && typeof node.rotation === 'function') {
                    fromNode = parseFloat(node.rotation());
                }
            } catch (e) {
                fromNode = NaN;
            }
            if (Number.isFinite(fromNode)) {
                return fromNode;
            }

            const hint = hints.find(value => Number.isFinite(value));
            return hint !== undefined ? hint : 0;
        },
        getAabbFitScale(width, height, rotation) {
            const fitEps = 1e-4;
            const borderRotation = this.borderConfig.rotation || 0;
            const relRad = this.deg2rad(rotation - borderRotation);
            const absCos = Math.abs(Math.cos(relRad));
            const absSin = Math.abs(Math.sin(relRad));
            const rotatedWidth = width * absCos + height * absSin;
            const rotatedHeight = width * absSin + height * absCos;

            let scale;
            if (this.borderConfig.gboxShape === 'circle') {
                const radius = Math.max(
                    Math.min(this.borderConfig.width, this.borderConfig.height) / 2,
                    1
                );
                const halfDiagonal = Math.hypot(width / 2, height / 2);
                scale = radius / Math.max(halfDiagonal, 1e-6);
            } else {
                const availWidth = Math.max(this.borderConfig.width, 1);
                const availHeight = Math.max(this.borderConfig.height, 1);
                scale = Math.min(
                    availWidth / Math.max(rotatedWidth, 1e-6),
                    availHeight / Math.max(rotatedHeight, 1e-6)
                );
            }

            if (!Number.isFinite(scale) || scale <= 0) {
                return 1;
            }

            // Exact max (60 mm at 90°) must count as fitting — not 0.999999.
            return scale >= 1 - fitEps ? 1 : Math.min(scale, 1);
        },
        applyLogoSizeAtCurrentPose(newWidth, newHeight, rotation) {
            const currentWidth = this.logoConfig.width;
            const currentHeight = this.logoConfig.height;
            const aabbScale = this.getAabbFitScale(newWidth, newHeight, rotation);

            if (aabbScale < 1) {
                newWidth *= aabbScale;
                newHeight *= aabbScale;
            }

            const center = this.getLogoVisualCenter(
                this.logoConfig.x,
                this.logoConfig.y,
                currentWidth,
                currentHeight,
                rotation
            );
            const gboxCenter = this.getRotatedPoint();
            const topLeftAtCenter = this.getLogoTopLeftForCenter(
                center.x,
                center.y,
                newWidth,
                newHeight,
                rotation
            );
            const chosenCenter = this.logoFitsGboxAtPose(
                newWidth,
                newHeight,
                topLeftAtCenter.x,
                topLeftAtCenter.y,
                rotation
            ) ? center : gboxCenter;

            const topLeft = this.getLogoTopLeftForCenter(
                chosenCenter.x,
                chosenCenter.y,
                newWidth,
                newHeight,
                rotation
            );

            this.logoConfig.width = newWidth;
            this.logoConfig.height = newHeight;
            this.logoConfig.rotation = rotation;
            this.logoConfig.x = topLeft.x;
            this.logoConfig.y = topLeft.y;
        },
        emitLogoSizeChange() {
            this.$emit('resize:logo', {
                scale: this.printPlace.gbox_settings.scale,
                config: this.logoConfig,
            });
            this.$nextTick(() => {
                this.emitLogoAreaStatus();
            });
            if (!(this.confirmed === true && this.editAfterSave)) {
                this.handleSaveVisualizationAndConfirm();
            }
        },
        updateImageSettings(settings) {
            let oldConfig = {
                x: this.logoConfig.x,
                y: this.logoConfig.y,
                width: this.logoConfig.width,
                height: this.logoConfig.height,
                rotation: this.logoConfig.rotation
            };

            let widthMM = isNaN(settings.width) ? 0 : parseFloat(settings.width);
            let heightMM = isNaN(settings.height) ? 0 : parseFloat(settings.height);

            let scale = this.printPlace.gbox_settings.scale;

            let currentHeight = this.logoConfig.height;
            let currentWidth = this.logoConfig.width;
            let newHeight = ((heightMM / 10) * scale.line) / scale.dim;
            let newWidth = ((widthMM / 10) * scale.line) / scale.dim;

            const currentWidthMM = ((currentWidth * scale.dim) / scale.line) * 10;
            const currentHeightMM = ((currentHeight * scale.dim) / scale.line) * 10;
            const heightChanged = currentHeightMM.toFixed(2) !== heightMM.toFixed(2);
            const widthChanged = currentWidthMM.toFixed(2) !== widthMM.toFixed(2);

            const requestedRotation = parseFloat(settings.rotation);
            const settingsRotation = Number.isFinite(requestedRotation) ? requestedRotation : NaN;
            const liveRotation = this.getLiveLogoRotation();
            const comparableSettingsRotation = Number.isFinite(settingsRotation) ? settingsRotation : liveRotation;
            const rotationChanged = !widthChanged && !heightChanged
                && Math.abs(liveRotation - comparableSettingsRotation) > 0.01;

            if (!heightChanged && !widthChanged && !rotationChanged) {
                return;
            }

            // Rotation-only input (including 0°). Size-only edits must not run this
            // with a stale width still sitting in the sidebar.
            if (rotationChanged) {
                this.fitLogoToRotation(comparableSettingsRotation);
                return;
            }

            if (
                (heightChanged || widthChanged)
                && currentWidth > 0
                && currentHeight > 0
                && Number.isFinite(newWidth)
                && Number.isFinite(newHeight)
            ) {
                if (heightChanged && !widthChanged) {
                    newWidth = (newHeight * currentWidth) / currentHeight;
                } else if (widthChanged && !heightChanged) {
                    newHeight = (newWidth * currentHeight) / currentWidth;
                } else if (Math.abs(newWidth - currentWidth) >= Math.abs(newHeight - currentHeight)) {
                    newHeight = (newWidth * currentHeight) / currentWidth;
                } else {
                    newWidth = (newHeight * currentWidth) / currentHeight;
                }

                this.applyLogoSizeAtCurrentPose(newWidth, newHeight, liveRotation);
                this.emitLogoSizeChange();
                return;
            }

            if (rotationChanged) {
                const topLeft = {x: -currentWidth / 2, y: -currentHeight / 2};
                const currentRotRad = this.deg2rad(liveRotation);
                const newRotRad = this.deg2rad(comparableSettingsRotation);
                const currentRotated = this.rotatePoint2(topLeft, currentRotRad);
                const newRotated = this.rotatePoint2(topLeft, newRotRad);

                this.logoConfig.rotation = comparableSettingsRotation;
                this.logoConfig.x = this.logoConfig.x + (newRotated.x - currentRotated.x);
                this.logoConfig.y = this.logoConfig.y + (newRotated.y - currentRotated.y);
            }

            let that = this;
            setTimeout(function () {
                let logoShape = that.$refs.logo.getNode();

                let oldScale = that.scale;
                that.scale = 100;
                that.zoomStage(that.pointConfig.x, that.pointConfig.y, that.scale / 100);

                let currentPos = {x: that.logoConfig.x, y: that.logoConfig.y};
                if (!checkIfInBorderBox.call(logoShape, currentPos)) {
                    that.logoConfig.x = oldConfig.x;
                    that.logoConfig.y = oldConfig.y;
                    that.logoConfig.width = oldConfig.width;
                    that.logoConfig.height = oldConfig.height;
                    that.logoConfig.rotation = oldConfig.rotation;
                }

                that.scale = oldScale;
                that.zoomStage(that.pointConfig.x, that.pointConfig.y, that.scale / 100);

                that.$emit(
                    'resize:logo',
                    {
                        "scale": that.printPlace.gbox_settings.scale,
                        "config": that.logoConfig
                    }
                )
            }, 1);

            this.$nextTick(() => {
                this.emitLogoAreaStatus();
            });

            if(!(this.confirmed ===  true && this.editAfterSave)){
                this.handleSaveVisualizationAndConfirm();
            }
        },
        adjustText() {
            if (this.textConfig.x === -1 && this.textConfig.y === -1) {
                const {x, y, width, height} = this.borderConfig;

                this.textConfig.x = x;
                this.textConfig.y = y;
                this.textConfig.rotation = this.borderConfig.rotation;
            }
        },
        getTextWidth() {
            const ctx = document.createElement('canvas').getContext('2d');
            ctx.font = `${this.textConfig.fontSize}px ${quoteFontFamily(this.textConfig.fontFamily)}`;
            return ctx.measureText(this.textConfig.text).width;
        },
        getTextHeight() {
            return this.textConfig.fontSize; // W przypadku czystego tekstu wysokość to rozmiar czcionki
        },
        calculateLogoFitInGbox(naturalWidth, naturalHeight) {
            const padding = 2;

            if (this.borderConfig.gboxShape === 'circle') {
                const radius = Math.max(this.borderConfig.width / 2 - padding, 1);
                const halfDiagonal = Math.hypot(naturalWidth / 2, naturalHeight / 2);
                const scale = radius / halfDiagonal;

                const imageWidth = naturalWidth * scale;
                const imageHeight = naturalHeight * scale;

                const borderRotation = this.borderConfig.rotation || 0;
                const borderHalf = this.rotatePoint2(
                    {x: this.borderConfig.width / 2, y: this.borderConfig.height / 2},
                    this.deg2rad(borderRotation)
                );
                const borderCenterX = this.borderConfig.x + borderHalf.x;
                const borderCenterY = this.borderConfig.y + borderHalf.y;
                const logoHalf = this.rotatePoint2(
                    {x: imageWidth / 2, y: imageHeight / 2},
                    this.deg2rad(borderRotation)
                );

                return {
                    x: borderCenterX - logoHalf.x,
                    y: borderCenterY - logoHalf.y,
                    width: imageWidth,
                    height: imageHeight,
                    rotation: this.borderConfig.rotation,
                };
            }

            const shapeWidth = this.borderConfig.width;
            const shapeHeight = this.borderConfig.height;
            const scale = Math.min(shapeWidth / naturalWidth, shapeHeight / naturalHeight);

            return {
                x: this.borderConfig.x,
                y: this.borderConfig.y,
                width: naturalWidth * scale,
                height: naturalHeight * scale,
                rotation: this.borderConfig.rotation,
            };
        },
        adjustImage(image, justUpdateImage = false) {
            const naturalWidth = image.naturalWidth;
            const naturalHeight = image.naturalHeight;

            if (justUpdateImage || !this.visualization || this.changedOriginalLogo === true) {
                if (naturalWidth > 0 && naturalHeight > 0) {
                    const fit = this.calculateLogoFitInGbox(naturalWidth, naturalHeight);
                    this.logoConfig.x = fit.x;
                    this.logoConfig.y = fit.y;
                    this.logoConfig.width = fit.width;
                    this.logoConfig.height = fit.height;
                    this.logoConfig.rotation = fit.rotation;
                }
            }

            this.logoConfig.image = image;
            this.logoConfig.visible = true;
            this.applyDdcLogoBlend();

            if (!this.afterCropLogo) {
                this.logoHistories = [];
                this.currentLogoHistoryIndex = -1;
            } else {
                this.afterCropLogo = false;
            }

            this.addHistory('logo');
            this.emitLogoAreaStatus();

            // Przekaż funkcję validateLogoRotation po załadowaniu logo
            this.$nextTick(() => {
                this.$emit('set:boundbox-validator', this.validateLogoRotation);
                this.$emit('set:boundbox-fitter', this.fitLogoToRotation);
            });
        },
        adjustDragBoundary() {
            if (this.currentShape === 'rect') {
                this.borderConfig = {...this.rectangleConfig};
                this.borderConfig.name = 'gboxBorder';
                this.borderConfig.draggable = false;
                this.borderConfig.stroke = 'red';
                this.borderConfig.strokeWidth = 1;
                this.borderConfig.gboxShape = 'rect';
            } else if (this.currentShape === 'circle') {
                // Greenbox w kształcie koła: obramowaniem jest pełny bounding box
                // okręgu, a flaga gboxShape='circle' przełącza logikę ograniczeń
                // (drag/transform/walidacja) na sprawdzanie względem okręgu.
                // Dzięki temu logo może poruszać się po całym kole, a nie tylko
                // po wpisanym w nie kwadracie.
                const centerX = this.circleConfig.x; // Środek okręgu X
                const centerY = this.circleConfig.y; // Środek okręgu Y
                const radius = this.circleConfig.radius; // Promień okręgu

                this.borderConfig.stroke = 'red';
                this.borderConfig.strokeWidth = 1;
                this.borderConfig.rotation = 0;
                this.borderConfig.x = centerX - radius;
                this.borderConfig.y = centerY - radius;
                this.borderConfig.width = radius * 2;
                this.borderConfig.height = radius * 2;
                this.borderConfig.gboxShape = 'circle';

            } else if (this.currentShape === 'shape') {
                // Pobieranie przesunięcia całego kształtu
                const shapeX = this.customShapeConfig.x; // Globalne X kształtu
                const shapeY = this.customShapeConfig.y; // Globalne Y kształtu

                // Pobieranie punktów definiujących kształt
                const points = this.customShapeConfig.points;
                const xPoints = points.filter((_, index) => index % 2 === 0); // Lokalne X punktów
                const yPoints = points.filter((_, index) => index % 2 !== 0); // Lokalne Y punktów

                // Obliczenie minimalnych i maksymalnych wartości punktów
                const minX = Math.min(...xPoints) + shapeX; // Globalne najmniejsze X
                const maxX = Math.max(...xPoints) + shapeX; // Globalne największe X
                const minY = Math.min(...yPoints) + shapeY; // Globalne najmniejsze Y
                const maxY = Math.max(...yPoints) + shapeY; // Globalne największe Y

                // Konfiguracja prostokąta obejmującego cały kształt z marginesem
                this.borderConfig = {
                    name: 'gboxBorder',
                    stroke: 'red',
                    strokeWidth: 1,
                    x: minX, // Lewa krawędź prostokąta
                    y: minY, // Górna krawędź prostokąta
                    width: (maxX - minX), // Szerokość prostokąta z marginesem
                    height: (maxY - minY), // Wysokość prostokąta z marginesem
                    visible: true,
                    draggable: false,
                    gboxShape: 'rect',
                };
                this.logoConfig.opacity = 0.7;
            }

            this.applyDdcLogoBlend();
            this.borderConfig.visible = false;
            this.borderConfig.draggable = false;
            this.pointConfig.visible = false;
            this.updatePointPosition();

        },
        scaleUpdateValue(inputValue) {
            const numericValue = parseFloat(inputValue.replace('%', '').trim());
            if (!isNaN(numericValue)) {
                this.scale = numericValue;
            }
        },
        handleClick() {
            alert('Prostokąt został kliknięty!');
        },
        async fetchProduct() {

            this.loading = true; // Ustaw flagę ładowania

            const urlParams = new URLSearchParams(window.location.search);
            // Domyślnie bierzemy metodę druku z URL
            this.printMethod = urlParams.get('print_method') ?? 'TF1';


            let variantsArray = urlParams.get('variants');
            if (variantsArray) {
                variantsArray = variantsArray.replaceAll(" ", "").split(',');
            } else {
                variantsArray = [];
            }

            let erpCode = urlParams.get('erp_code') ?? 'V4201-19';
            if (variantsArray.length > 0) {
                erpCode = variantsArray[0];
            }

            const params = new URLSearchParams({
                erp_code: erpCode,
                print_place_name: urlParams.get('print_place_name') ?? 'panel 1',
                print_place_size: urlParams.get('print_place_size') ?? '200x120',
                print_method: this.printMethod,
                uuid: urlParams.get('uuid') ?? null,
                variants: urlParams.get('variants') ?? null,
            });

            const response = await fetch(`/api/product?${params}`)
            if (!response.ok) {
                throw new Error(`Status: ${response.status}`)
            }
            const responseData = await response.json();

            this.product = responseData.product;
            if (responseData.visualization) {
                if (responseData.visualization.logo) {
                    this.visualization = responseData.visualization;
                    if (!responseData.visualization.confirmed) {
                        const v = responseData.visualization.validated;
                        const qualityAlreadyValidated = v === true || v === 1 || v === '1';
                        if (!qualityAlreadyValidated) {
                            eventBus.forceQualityRecheck = true;
                        }
                    }

                }

                this.fakeVisualization = responseData.visualization;

                if (responseData.visualization.print_method) {
                    this.printMethod = responseData.visualization.print_method;
                } else if (responseData.print_method) {
                    this.printMethod = responseData.print_method;
                }

                if (responseData.visualization.user_id) {
                    this.userId = responseData.visualization.user_id;
                }

                const confirmed = responseData.visualization.confirmed ?? false;
                this.$emit('update:visualization-confirmed', confirmed);
            } else if (responseData.print_method) {
                this.printMethod = responseData.print_method;
            }

            if (!this.userId) {
                const urlParams = new URLSearchParams(window.location.search);
                this.userId = urlParams.get('user_id');
            }

            this.printPlace = responseData.printPlace;
            this.pickedVariant = this.printPlace.product_erp_code;
            this.extensions = responseData.extensions;
            this.variants = responseData.variants;

            this.$emit('update:extensions', this.extensions)
            this.$emit('update:print_method', this.printMethod)
            this.$emit('update:grav_color', this.printPlace?.grav_color ?? null)

            if (!this.product || !this.printPlace) {
                this.paramsNotValid = true;
                this.$emit('params:not-valid')
                return;
            }

            this.init();

            if (this.visualization) {
                this.visualizationLoaded = true;

                if (this.visualization.media[0].mime_type !== 'image/tiff' && !(this.printMethod.startsWith('L') || this.printMethod.startsWith('TC'))) {

                    this.visualization.logo.preview_url = this.visualization.media[0].original_url;
                }
                this.logoConfig = {...this.visualization.logo_config};
                this.logoConfig.dragBoundFunc = shapeDragBoundFunc;
                this.applyDdcLogoBlend();

                if (this.visualization.text_config && this.visualization.text_config.visible) {
                    this.textConfig = {...this.visualization.text_config};
                    this.textConfig.dragBoundFunc = shapeDragBoundFunc;
                }

                this.$emit(
                    'visualization:loaded',
                    this.visualization
                )

                this.$emit(
                    'resize:logo',
                    {
                        "scale": this.printPlace.gbox_settings.scale,
                        "config": this.logoConfig
                    }
                )

                this.$emit(
                    'history:colors',
                    {
                        "colors": {...this.visualization.colors}
                    }
                )
            }

            const editModeParam = urlParams.get('edit_mode');
            if (editModeParam === '1') {
                this.$emit('update:edit-after-save', true);
            }

        },
        init() {
            this.logoConfig.visible = false;

            if (this.printPlace) {

                if (this.printPlace.gbox_settings) {

                    if (this.printPlace.gbox_settings.shape === 'rect') {
                        this.currentShape = 'rect';
                        this.rectangleConfig = this.printPlace.gbox_settings.config;
                        this.rectangleConfig.visible = true;
                        this.circleConfig.visible = false;
                        this.customShapeConfig.visible = false;
                    } else if (this.printPlace.gbox_settings.shape === 'circle') {
                        this.currentShape = 'circle';
                        this.circleConfig = this.printPlace.gbox_settings.config;
                        this.rectangleConfig.visible = false;
                        this.circleConfig.visible = true;
                        this.customShapeConfig.visible = false;
                    } else if (this.printPlace.gbox_settings.shape === 'custom') {
                        this.currentShape = 'shape';
                        this.customShapeConfig = this.printPlace.gbox_settings.config;
                        this.rectangleConfig.visible = false;
                        this.circleConfig.visible = false;
                        this.customShapeConfig.visible = true;
                    }

                    this.customShapeConfig.draggable = false;
                    this.rectangleConfig.draggable = false;
                    this.circleConfig.draggable = false;

                    this.applyGreenboxBackgroundConfig();


                    this.adjustDragBoundary();
                }

                this.setImage()
                this.adjustText();
                this.$refs.layer.getNode().batchDraw();
                this.captureInitialStageState();
            }

            this.$emit('update:border-rotation', this.borderConfig.rotation || 0);
        },
        setImage() {
            const image = new window.Image();

            let media = this.printPlace?.media[0];

            if (media) {
                image.src = media.original_url;
            } else {
                image.src = '/img/missing.jpg'
            }

            image.onload = () => {
                // Ustawiamy obraz
                this.image = image;

                // Pobieramy naturalne wymiary obrazu
                const naturalWidth = image.naturalWidth;
                const naturalHeight = image.naturalHeight;

                // Wymiary sceny
                const stageWidth = this.stageConfig.width;
                const stageHeight = this.stageConfig.height;

                // Obliczamy skalę, aby dopasować obraz do sceny zachowując proporcje
                const scale = Math.min(stageWidth / naturalWidth, stageHeight / naturalHeight);

                // Obliczamy nowe wymiary obrazu
                const imageWidth = naturalWidth * scale;
                const imageHeight = naturalHeight * scale;

                // Centrujemy obraz na scenie
                const x = (stageWidth - imageWidth) / 2;
                const y = (stageHeight - imageHeight) / 2;

                // Aktualizujemy konfigurację obrazu
                this.imageConfig = {
                    image: image,
                    x: x,
                    y: y,
                    width: imageWidth,
                    height: imageHeight,
                    name: 'backgroundImage', // Upewnij się, że nazwa jest dodana
                };
            };
        },
        drawCustomShape(context, shape) {
            context.beginPath();
            const points = this.customShapeConfig.points;

            // Rysowanie kształtu
            for (let i = 0; i < points.length; i += 2) {
                if (i === 0) {
                    context.moveTo(points[i], points[i + 1]);
                } else {
                    context.lineTo(points[i], points[i + 1]);
                }
            }

            // Zamykanie kształtu
            context.closePath();
            context.fillStrokeShape(shape);
        },
        getRotatedPoint() {
            // Oblicz środek borderConfig w lokalnych współrzędnych
            const centerX = this.borderConfig.x + this.borderConfig.width / 2;
            const centerY = this.borderConfig.y + this.borderConfig.height / 2;

            // Jeśli borderConfig ma rotację, przelicz punkt uwzględniając rotację
            if (this.borderConfig.rotation && this.borderConfig.rotation !== 0) {
                // Rotacja w Konva odbywa się wokół punktu (x, y) - lewego górnego rogu
                // Musimy przeliczyć środek z uwzględnieniem rotacji
                return rotatePoint(
                    this.borderConfig.x,
                    this.borderConfig.y,
                    centerX,
                    centerY,
                    this.borderConfig.rotation
                );
            }

            return {x: centerX, y: centerY};
        },
        minusChangeStageScale() {
            if (this.scale > 100) { // Zapobieganie zerowej lub negatywnej skali
                this.scale -= 10;
                const rotatedPoint = this.getRotatedPoint();
                this.zoomStage(rotatedPoint.x, rotatedPoint.y, this.scale / 100);
            }
        },
        plusChangeStageScale() {
            if (this.scale < 300) { // Ograniczenie maksymalnego powiększenia
                this.scale += 10;
                const rotatedPoint = this.getRotatedPoint();
                this.zoomStage(rotatedPoint.x, rotatedPoint.y, this.scale / 100);
            }
        },
        zoomStage(targetX, targetY, scaleFactor) {
            // Pobranie referencji do sceny
            const stage = this.$refs.stage.getNode();

            const newScale = scaleFactor;
            if (Math.abs(newScale - 1) < 0.0001 && this.initialStageState) {
                stage.scale({...this.initialStageState.scale});
                stage.position({...this.initialStageState.position});
                stage.batchDraw();
                return;
            }
            const container = stage.container();
            const containerWidth = (container?.clientWidth || stage.width());
            const containerHeight = (container?.clientHeight || stage.height());

            stage.scale({x: newScale, y: newScale});

            const newPos = {
                x: containerWidth / 2 - targetX * newScale,
                y: containerHeight / 2 - targetY * newScale,
            };

            stage.position(newPos);

            // Odświeżenie sceny
            stage.batchDraw();
        },
        captureInitialStageState() {
            this.$nextTick(() => {
                if (this.initialStageState) {
                    return;
                }
                const stage = this.$refs.stage?.getNode();
                if (!stage) {
                    return;
                }
                this.initialStageState = {
                    scale: {x: stage.scaleX(), y: stage.scaleY()},
                    position: {...stage.position()}
                };
            });
        },
        handleDragMove(e) { //podczas dragu nie wazne czy w trans czy bez
            const node = e.target;

            if (!e) {
                this.selectElement('text')
            }

            if (node) {
                if (node.attrs.name === "logoImage") {
                    if (!this.selectedNode || this.selectedNode?.attrs?.name === 'textConfig') {
                        this.selectElement('logo')
                    }
                    this.logoConfig.x = node.x();
                    this.logoConfig.y = node.y();
                }

                if (node.attrs.name === "textConfig") {
                    if (!this.selectedNode || this.selectedNode?.attrs?.name === 'logoImage') {
                        this.selectElement('text')
                    }
                    this.syncTextNodeToConfig(node);
                }
            }
        },
        handleTransformEnd(e) { // na zakonczenie rotacji lub resizu
            const node = e.target;

            const logoNode = this.$refs.logo.getNode();

            logoNode.width(logoNode.width() * logoNode.scaleX());
            logoNode.height(logoNode.height() * logoNode.scaleY());
            logoNode.scaleX(1);
            logoNode.scaleY(1);

            const absScale = logoNode.getAbsoluteScale();
            const widthAbs = logoNode.width();
            const heightAbs = logoNode.height();

            if (node) {
                if (node.attrs.name === "logoImage") {
                    this.logoConfig.x = node.x();
                    this.logoConfig.y = node.y();
                    this.logoConfig.width = widthAbs;
                    this.logoConfig.height = heightAbs;
                    this.logoConfig.rotation = node.rotation();

                    this.addHistory('logo')
                    this.$emit(
                        'resize:logo',
                        {
                            "scale": this.printPlace.gbox_settings.scale,
                            "config": this.logoConfig
                        }
                    )
                    this.emitLogoAreaStatus();
                }

                if (node.attrs.name === "textConfig") {
                    this.syncTextNodeToConfig(node);
                    this.addHistory('text');
                }
            }
        },
        syncTextNodeToConfig(node) {
            if (!node) {
                return;
            }
            this.textConfig.x = node.x();
            this.textConfig.y = node.y();
            this.textConfig.rotation = node.rotation();
        },
        fastAction(action) {
            let node = this.selectedNode ? this.selectedNode.attrs.name : null;
            const textNode = this.$refs.text.getNode(); // Upewnij się, że masz referencję do v-text
            const textWidth = textNode.getClientRect().width; // Oblicz szerokość tekstu
            const textHeight = textNode.getClientRect().height; // Oblicz wysokość tekstu
            const textX = textNode.getClientRect().x; // Oblicz wysokość tekstu
            const textY = textNode.getClientRect().y; // Oblicz wysokość tekstu

            if (action === 'delete') {
                if (node === 'logoImage') {
                    this.$emit('remove:logo')
                }

                if (node === 'textConfig') {
                    this.$emit('remove:text')
                }

                this.selectedNode = null;
                this.$nextTick(() => {
                    const transformer = this.$refs.transformer.getNode();
                    transformer.nodes([]);
                    transformer.getLayer().batchDraw();
                });

                return;
            }

            if (action === 'crop') {
                if (node === 'logoImage' && this.cropModalOpen === false) {
                    this.loadCropFile()
                }

                return;
            }

            this.$emit(
                'resize:logo',
                {
                    "scale": this.printPlace.gbox_settings.scale,
                    "config": this.logoConfig
                }
            )

            this.$refs.layer.getNode().batchDraw();

            if (node === 'logoImage') {
                if (action === 'delete') {
                    this.clearHistory('logo')
                } else {
                    this.addHistory('logo')
                }
            }

            if (node === 'textConfig') {
                if (action === 'delete') {
                    this.clearHistory('text')
                } else {
                    this.addHistory('text')
                }
            }

            // alignment
            const logoShape = this.$refs.logo.getNode();
            const textShape = this.$refs.text.getNode();
            const stage = logoShape.getStage();

            let shapeRect = null;
            let rotatedRect = null;

            if (node === 'logoImage') {
                let currentRotation = logoShape.rotation();
                logoShape.rotation(0)
                shapeRect = logoShape.getClientRect();
                logoShape.rotation(currentRotation);
                rotatedRect = calculateRotatedCorners(shapeRect.x, shapeRect.y, logoShape.width() * logoShape.getAbsoluteScale().x, logoShape.height() * logoShape.getAbsoluteScale().y, logoShape.rotation());
            } else if (node === 'textConfig') {
                let currentRotation = textShape.rotation();
                textShape.rotation(0)
                shapeRect = textShape.getClientRect();
                textShape.rotation(currentRotation);
                rotatedRect = calculateRotatedCorners(shapeRect.x, shapeRect.y, textShape.width() * textShape.getAbsoluteScale().x, textShape.height() * textShape.getAbsoluteScale().y, textShape.rotation());
            } else {
                return;
            }

            const borderNode = stage.findOne('.gboxBorder');
            const borderRotation = borderNode.rotation();
            let borderRect = borderNode.getClientRect();

            // Get unrotated border rectangle if border is rotated
            if (borderRotation !== 0) {
                borderNode.rotation(0);
                borderRect = borderNode.getClientRect();
                borderNode.rotation(borderRotation);
            }

            let xCoords = rotatedRect.map(p => p.x)
            let yCoords = rotatedRect.map(p => p.y)

            let boundingBox = {
                x1: Math.min(...xCoords),
                x2: Math.max(...xCoords),
                y1: Math.min(...yCoords),
                y2: Math.max(...yCoords),
            };

            let deltaX = 0;
            let deltaY = 0;

            const fastActionCircle = getGboxCircle(borderNode);

            // Greenbox w kształcie koła: wyrównujemy względem skrajnych punktów okręgu,
            // a następnie dociągamy narożniki logo do wnętrza okręgu.
            if (fastActionCircle) {
                const boxCenterX = (boundingBox.x1 + boundingBox.x2) / 2;
                const boxCenterY = (boundingBox.y1 + boundingBox.y2) / 2;

                if (action === 'left') {
                    deltaX = (fastActionCircle.cx - fastActionCircle.radius) - boundingBox.x1;
                    deltaY = 0;
                }
                if (action === 'right') {
                    deltaX = (fastActionCircle.cx + fastActionCircle.radius) - boundingBox.x2;
                    deltaY = 0;
                }
                if (action === 'top') {
                    deltaY = (fastActionCircle.cy - fastActionCircle.radius) - boundingBox.y1;
                    deltaX = 0;
                }
                if (action === 'bottom') {
                    deltaY = (fastActionCircle.cy + fastActionCircle.radius) - boundingBox.y2;
                    deltaX = 0;
                }
                if (action === 'center') {
                    deltaX = fastActionCircle.cx - boxCenterX;
                    deltaY = 0;
                }
                if (action === 'middle') {
                    deltaY = fastActionCircle.cy - boxCenterY;
                    deltaX = 0;
                }

                const shiftedCorners = rotatedRect.map(p => ({x: p.x + deltaX, y: p.y + deltaY}));
                const {dx, dy} = clampCornersToCircle(shiftedCorners, fastActionCircle);
                deltaX += dx;
                deltaY += dy;
            } else if (borderRotation !== 0) {
                const borderCenterX = borderRect.x + borderRect.width / 2;
                const borderCenterY = borderRect.y + borderRect.height / 2;

                // Transform shape corners to border's unrotated coordinate system
                const transformedRect = rotatedRect.map(point =>
                    rotatePoint(borderRect.x, borderRect.y, point.x, point.y, -borderRotation)
                );

                let transformedXCoords = transformedRect.map(p => p.x);
                let transformedYCoords = transformedRect.map(p => p.y);

                let transformedBoundingBox = {
                    x1: Math.min(...transformedXCoords),
                    x2: Math.max(...transformedXCoords),
                    y1: Math.min(...transformedYCoords),
                    y2: Math.max(...transformedYCoords),
                };

                // Use unrotated border rectangle for alignment calculations
                const unrotatedBorderRect = {
                    x: borderCenterX - borderRect.width / 2,
                    y: borderCenterY - borderRect.height / 2,
                    width: borderRect.width,
                    height: borderRect.height
                };

                if (action === 'left') {
                    deltaX = unrotatedBorderRect.x - transformedBoundingBox.x1;
                    deltaY = 0;
                }

                if (action === 'right') {
                    deltaX = unrotatedBorderRect.x + unrotatedBorderRect.width - transformedBoundingBox.x2;
                    deltaY = 0;
                }

                if (action === 'top') {
                    deltaY = unrotatedBorderRect.y - transformedBoundingBox.y1;
                    deltaX = 0;
                }

                if (action === 'bottom') {
                    deltaY = unrotatedBorderRect.y + unrotatedBorderRect.height - transformedBoundingBox.y2;
                    deltaX = 0;
                }

                if (action === 'center') {
                    deltaY = 0;
                    deltaX = unrotatedBorderRect.x + unrotatedBorderRect.width * 0.5 - (transformedBoundingBox.x1 + (transformedBoundingBox.x2 - transformedBoundingBox.x1) * 0.5);
                }

                if (action === 'middle') {
                    deltaY = unrotatedBorderRect.y + unrotatedBorderRect.height * 0.5 - (transformedBoundingBox.y1 + (transformedBoundingBox.y2 - transformedBoundingBox.y1) * 0.5);
                    deltaX = 0;
                }

                // Transform the delta back to the original coordinate system
                const rotatedDelta = rotatePoint(0, 0, deltaX, deltaY, borderRotation);
                deltaX = rotatedDelta.x;
                deltaY = rotatedDelta.y;
            } else {
                // Original logic for non-rotated borders
                if (action === 'left') {
                    deltaX = borderRect.x - boundingBox.x1;
                    deltaY = 0;
                }

                if (action === 'right') {
                    deltaX = borderRect.x + borderRect.width - boundingBox.x2;
                    deltaY = 0;
                }

                if (action === 'top') {
                    deltaY = borderRect.y - boundingBox.y1;
                    deltaX = 0;
                }

                if (action === 'bottom') {
                    deltaY = borderRect.y + borderRect.height - boundingBox.y2;
                    deltaX = 0;
                }

                if (action === 'center') {
                    deltaY = 0;
                    deltaX = borderRect.x + borderRect.width * 0.5 - (boundingBox.x1 + (boundingBox.x2 - boundingBox.x1) * 0.5);
                }

                if (action === 'middle') {
                    deltaY = borderRect.y + borderRect.height * 0.5 - (boundingBox.y1 + (boundingBox.y2 - boundingBox.y1) * 0.5);
                    deltaX = 0;
                }
            }

            deltaX /= this.scale / 100.0;
            deltaY /= this.scale / 100.0;

            if (node === 'logoImage') {
                this.logoConfig.x += deltaX;
                this.logoConfig.y += deltaY;
            } else if (node === 'textConfig') {
                this.textConfig.x += deltaX;
                this.textConfig.y += deltaY;
            }
        },
        async addHistory(mode, onlySaveVisualization = false) {

            if (mode === 'logo') {
                let colors = JSON.parse(JSON.stringify(this.colors));

                let forceSave = false;

                if (onlySaveVisualization === false) {
                    if (this.logoHistories.length !== 0 && this.logoHistories.length - 1 !== this.currentLogoHistoryIndex) {
                        this.logoHistories.splice(this.currentLogoHistoryIndex + 1);

                        this.currentLogoHistoryIndex = this.logoHistories.length - 1;
                    }


                    const croppedFileName = this.cropFileNameAfter;
                    if (croppedFileName) {
                        colors.file = croppedFileName;
                        forceSave = true;
                        this.cropFileNameAfter = null;

                        this.$emit('crop:file-name', colors.file)

                    }

                    this.logoHistories.push({
                        'logoConfig': {...this.logoConfig},
                        'colors': colors
                    });

                    this.currentLogoHistoryIndex++;
                }

                try {
                    await this.saveVisualization(colors, forceSave);
                } catch (error) {
                    console.log(error)
                }

            } else {
                if (this.textHistories.length !== 0 && this.textHistories.length - 1 !== this.currentTextHistoryIndex) {
                    this.textHistories.splice(this.currentTextHistoryIndex + 1);

                    this.currentTextHistoryIndex = this.textHistories.length - 1;
                }

                this.textHistories.push({
                    'textConfig': {...this.textConfig}
                });

                this.currentTextHistoryIndex++;

                try {
                    let colors = JSON.parse(JSON.stringify(this.colors));

                    await this.saveVisualization(colors);
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async saveVisualizationSnap() {
            await this.runCaptureWithHiddenGreenbox(() => this.updateVisualizationSnap());
        },
        async saveVisualization(colors, forceSave = false) {
            if (this.confirmed === true) {
                if (forceSave === false) {
                    return;
                }
            }
            const urlParams = new URLSearchParams(window.location.search);

            let tmp = {...this.logoConfig};
            let tmpText = null;

            if (this.textConfig.visible) {
                tmpText = JSON.stringify({...this.textConfig});
            }
            let blob = null;

            if (tmp && tmp.image && tmp.image.src) {
                const response = await fetch(tmp.image.src);
                blob = await response.blob();
            }

            const formData = new FormData();
            if (tmp.image) {
                delete tmp.image;
            }

            formData.append('image', blob); // bez nazwy pliku
            formData.append('logoConfig', JSON.stringify(tmp));
            formData.append('textConfig', tmpText);
            formData.append('colors', JSON.stringify(colors));
            formData.append('logo_id', this.imageData ? this.imageData.id : null);
            formData.append('print_place_id', this.printPlace.id);
            formData.append('product_id', this.product.id);
            formData.append('print_method', this.fakeVisualization?.print_method ?? urlParams.get('print_method') ?? 'TF1');
            formData.append('uuid', this.uuid);
            formData.append('variants', this.variants.map((item) => item.product_erp_code));

            if (this.userId) {
                formData.append('user_id', this.userId);
            } else {
                const userIdFromUrl = urlParams.get('user_id');
                if (userIdFromUrl) {
                    formData.append('user_id', userIdFromUrl);
                }
            }

            if (this.changedOriginalLogo === true) {
                formData.append('changed_original_logo', true);
                this.changedOriginalLogo = false;
            }

            let quality = this.qualityScore;
            if (quality === null || quality === undefined) {
                quality = this.visualization?.quality ?? 0;
            }

            formData.append('quality_score', quality);

            const apiResponse = await fetch('/api/save-visualization', {
                method: 'POST',
                body: formData,
            });

            return apiResponse;
        },
        async handleSaveVisualizationAndConfirm() {
            const colors = JSON.parse(JSON.stringify(this.colors));
            try {
                await this.saveVisualization(colors, true);
                this.$emit('update:edit-after-save', false);
            } catch (error) {
                console.error('Błąd podczas zapisywania wizualizacji:', error);
            }
        },
        removedTextContentHideText() {
            this.textConfig.visible = false;
        },
        clearHistory(mode) {
            if (mode === 'logo') {
                this.logoHistories = [];
                this.currentLogoHistoryIndex = -1;
            } else {
                this.textHistories = [];
                this.currentTextHistoryIndex = -1;
            }
        },
        loadPrevious() {
            if (this.selectedNode) {

                if (this.selectedNode.attrs.name === "logoImage") {
                    if (this.logoHistories[this.currentLogoHistoryIndex - 1] !== undefined) {
                        this.currentLogoHistoryIndex = this.currentLogoHistoryIndex - 1;
                    }
                }

                if (this.selectedNode.attrs.name === "textConfig") {
                    if (this.textHistories[this.currentTextHistoryIndex - 1] !== undefined) {
                        this.currentTextHistoryIndex = this.currentTextHistoryIndex - 1;
                    }
                }

                this.loadHistory();
            }

        },
        loadNext() {
            if (this.selectedNode) {
                if (this.selectedNode.attrs.name === "logoImage") {
                    if (this.logoHistories[this.currentLogoHistoryIndex + 1]) {
                        this.currentLogoHistoryIndex = this.currentLogoHistoryIndex + 1;
                    }
                }

                if (this.selectedNode.attrs.name === "textConfig") {
                    if (this.textHistories[this.currentTextHistoryIndex + 1]) {
                        this.currentTextHistoryIndex = this.currentTextHistoryIndex + 1;
                    }
                }

                this.loadHistory();
            }
        },
        loadHistory() {
            if (this.selectedNode) {
                if (this.selectedNode.attrs.name === "logoImage") {
                    this.logoConfig = {...this.logoHistories[this.currentLogoHistoryIndex].logoConfig};
                    this.applyDdcLogoBlend();

                    this.$emit(
                        'resize:logo',
                        {
                            "scale": this.printPlace.gbox_settings.scale,
                            "config": this.logoConfig
                        }
                    )

                    this.$emit(
                        'history:colors',
                        {
                            "colors": {...this.logoHistories[this.currentLogoHistoryIndex].colors}
                        }
                    )
                }

                if (this.selectedNode.attrs.name === "textConfig") {
                    let currentText = this.textConfig.text;
                    let nextHistory = {...this.textHistories[this.currentTextHistoryIndex].textConfig};
                    nextHistory.text = currentText;
                    this.textConfig = nextHistory;
                }
            }
        },
        handleDragEnd(event) { // na zakonczenie dragu - przy dropie - nie wazne czy w trans czy bez
            const node = event.target; // Obiekt, który został przeciągnięty
            if (node && node.attrs.name === "logoImage") {
                this.addHistory('logo');
            }

            if (node && node.attrs.name === "textConfig") {
                this.syncTextNodeToConfig(node);
                this.addHistory('text');
            }

            this.validateBoxing();
        },
        async cropLogo(logoBase, shouldReplace = true, coordinates) {
            this.afterCropLogo = true;

            if (shouldReplace) {
                await this.replaceRealImage(logoBase, coordinates)
            }

            setTimeout(() => {
                this.updateImage(logoBase, true);
                this.cropModalOpen = false;

            }, 500);
        },
        validateBoxing() {
            const textNode = this.$refs.text?.getNode && this.$refs.text.getNode();
            const borderNode = this.$refs.border?.getNode && this.$refs.border.getNode();

            if (!textNode || !borderNode) {
                eventBus.textValidation = true;
                this.$emit('update:text-validation', true);
                return true;
            }

            // getClientRect() zwraca axis-aligned bounding box, który już uwzględnia rotację
            const textRect = textNode.getClientRect();
            const borderRect = borderNode.getClientRect();

            // Sprawdź czy tekst mieści się w greenboxie
            let fits;
            const circle = getGboxCircle(borderNode);
            if (circle) {
                // Dla koła sprawdzamy obrócone narożniki tekstu względem okręgu.
                const textRotation = textNode.rotation();
                textNode.rotation(0);
                const unrotatedTextRect = textNode.getClientRect();
                textNode.rotation(textRotation);

                const textScale = textNode.getAbsoluteScale();
                const textCorners = calculateRotatedCorners(
                    unrotatedTextRect.x,
                    unrotatedTextRect.y,
                    textNode.width() * textScale.x,
                    textNode.height() * textScale.y,
                    textRotation
                );

                fits = cornersInsideCircle(textCorners, circle, 0);
            } else {
                fits = (
                    textRect.x >= borderRect.x &&
                    textRect.y >= borderRect.y &&
                    textRect.x + textRect.width <= borderRect.x + borderRect.width &&
                    textRect.y + textRect.height <= borderRect.y + borderRect.height
                );
            }

            if (fits) {
                eventBus.textValidation = true;
                this.lastValidText = this.textConfig.text;
            } else {
                eventBus.textValidation = false;
            }

            // Emituj stan walidacji do komponentów nadrzędnych
            this.$emit('update:text-validation', fits);

            return fits;
        },
        async loadCropFile() {
            try {
                const candidates = this.getCropFileCandidates();
                let blobData = null;

                for (const fileName of candidates) {
                    const response = await fetch(`/api/file?file_name=${encodeURIComponent(fileName)}&uuid=${this.uuid}`)
                    if (response.ok) {
                        blobData = await response.blob();
                        break;
                    }
                }

                if (!blobData) {
                    throw new Error('Nie znaleziono pliku logo do przycięcia');
                }

                this.cropFileUrl = URL.createObjectURL(blobData);

                this.cropModalOpen = true;

            } catch (error) {
                console.error('Error: ', error)
            }
        },
        getCropFileCandidates() {
            const fileName = this.colors?.file;
            if (!fileName) {
                return [];
            }

            const extension = fileName.includes('.') ? fileName.slice(fileName.lastIndexOf('.') + 1) : '';
            const baseName = fileName.slice(0, fileName.lastIndexOf('.')).replace(/-crop$/, '');
            const cropFileName = `${baseName}-crop.${extension}`;
            const baseFileName = `${baseName}.${extension}`;

            if (fileName.includes('-crop.')) {
                return [fileName, baseFileName];
            }

            return [fileName, cropFileName];
        },
        resolveCropInputFileName() {
            const fileName = this.colors?.file;
            if (!fileName) {
                return fileName;
            }

            if (fileName.includes('-crop.')) {
                return fileName.replace('-crop.', '.');
            }

            return fileName;
        },
        async replaceRealImage(cropLogoUrl, coordinates) {
            try {

                const formData = new FormData();
                formData.append('coordinates', JSON.stringify(coordinates));
                formData.append('file_name', this.resolveCropInputFileName());
                formData.append('uuid', this.uuid);

                // Wysyłanie na API
                const apiResponse = await fetch('/api/replace-file', {
                    method: 'POST',
                    body: formData,
                });

                if (!apiResponse.ok) {
                    throw new Error(`Błąd podczas wysyłania na API: ${apiResponse.status}`);
                }

                const data = await apiResponse.json();

                this.cropFileNameAfter = data.file_name;

            } catch (error) {

            }
        },
        async updateVisualizationSnap() {
            const stage = this.$refs.stage.getStage();

            const rotatedPoint = this.getRotatedPoint();
            this.scale = 100;
            this.zoomStage(rotatedPoint.x, rotatedPoint.y, this.scale / 100);

            const dataURL = stage.toDataURL({pixelRatio: 2});
            let success = false;
            try {
                const response = await fetch(dataURL);
                const blob = await response.blob();
                const urlParams = new URLSearchParams(window.location.search);

                const formData = new FormData();
                formData.append('image', blob, 'visualization.png');
                formData.append('uuid', this.uuid);

                // const pdfResponse = await fetch('/api/file/download-pdf', {
                const pdfResponse = await fetch('/api/file/visualization-snap', {
                    method: 'POST',
                    body: formData,
                });
                if (!pdfResponse.ok) {
                    throw new Error(`Status: ${pdfResponse.status}`);
                }

                success = true;
            } catch (error) {
                console.error('Błąd podczas generowania snap:', error);
            }
        },
        async downloadVisualization() {
            const type = this.downloadVisualizationType;
            const stage = this.$refs.stage.getStage();

            if (type === 'png') {
                const dataURL = stage.toDataURL({pixelRatio: 2});
                const link = document.createElement('a');
                link.download = 'visualization.png';
                link.href = dataURL;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.$emit('download:finished', {type, success: true});
                return;
            } else if (type === 'pdf') {
                // Reset zoom to default 100% before exporting PDF using the same centering logic as UI controls
                const rotatedPoint = this.getRotatedPoint();
                this.scale = 100;
                this.zoomStage(rotatedPoint.x, rotatedPoint.y, this.scale / 100);

                const dataURL = stage.toDataURL({pixelRatio: 2});
                let success = false;
                try {
                    const response = await fetch(dataURL);
                    const blob = await response.blob();
                    const logoBlob = await this.prepareLogoFile(this.logoConfig.image.src);

                    const urlParams = new URLSearchParams(window.location.search);


                    let variantsArray = urlParams.get('variants');
                    if (variantsArray) {
                        variantsArray = variantsArray.replaceAll(" ", "").split(',');
                    } else {
                        variantsArray = [];
                    }

                    let erpCode = urlParams.get('erp_code') ?? 'V4201-19';
                    if (variantsArray.length > 0) {
                        erpCode = variantsArray[0];
                    }


                    const formData = new FormData();
                    formData.append('erp_code', erpCode);
                    formData.append('print_place_name', urlParams.get('print_place_name') ?? 'panel 1');
                    formData.append('print_place_size', urlParams.get('print_place_size') ?? '200x150');
                    formData.append('print_method', urlParams.get('print_method') ?? 'TF1');
                    formData.append('image', blob, 'visualization.png');
                    formData.append('logo', logoBlob, logoBlob.name);
                    formData.append('colors', JSON.stringify(this.colors.colors));
                    formData.append('language', urlParams.get('lang') ?? 'pl');
                    formData.append('uuid', this.uuid);
                    if (this.confirmed === true && this.editAfterSave === true) {
                        formData.append('forceDirty', '1');
                    }

                    let width = 0;
                    let height = 0;

                    let scale = this.printPlace.gbox_settings.scale.dim / this.printPlace.gbox_settings.scale.line;
                    let widthPx = this.logoConfig.width;
                    let heightPx = this.logoConfig.height;

                    width = (scale * widthPx * 10).toFixed(2);
                    height = (scale * heightPx * 10).toFixed(2);
                    formData.append('width', width);
                    formData.append('height', height);
                    formData.append('variants', this.variants.map((item) => item.product_erp_code));

                    const pdfResponse = await fetch('/api/file/download-pdf', {
                        method: 'POST',
                        body: formData,
                    });
                    if (!pdfResponse.ok) {
                        throw new Error(`Status: ${pdfResponse.status}`);
                    }
                    const pdfBlob = await pdfResponse.blob();

                    const pdfUrl = window.URL.createObjectURL(pdfBlob);

                    const link = document.createElement('a');
                    link.href = pdfUrl;
                    link.download = 'visualization.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    window.URL.revokeObjectURL(pdfUrl);
                    success = true;
                } catch (error) {
                    console.error('Błąd podczas generowania PDF:', error);
                } finally {
                    this.$emit('download:finished', {type, success});
                }
            }

        },
        calculateLogoAreaCm2() {
            const scale = this.printPlace?.gbox_settings?.scale;
            if (!scale || !scale.dim || !scale.line) {
                return null;
            }
            if (!this.logoConfig?.width || !this.logoConfig?.height) {
                return null;
            }
            const ratio = scale.dim / scale.line;
            return this.logoConfig.width * this.logoConfig.height * Math.pow(ratio, 2);
        },
        emitLogoAreaStatus() {
            const maxArea = getPrintMethodArea(this.printMethod);
            const currentArea = this.calculateLogoAreaCm2();

            const exceeded = maxArea !== null && currentArea !== null ? currentArea > maxArea : false;

            this.$emit('logo-area:status', {
                exceeded,
                maxArea,
                currentArea,
            });
        },
        async prepareLogoFile(logoSrc) {
            try {
                const response = await fetch(logoSrc);
                const blob = await response.blob();

                const mimeType = blob.type || 'image/png';
                let fileName = 'logo.png';

                if (mimeType === 'image/svg+xml') {
                    const originalName = this.imageData?.file_name || '';
                    fileName = originalName.toLowerCase().endsWith('.svg') ? originalName : 'logo.svg';
                } else if (mimeType === 'image/jpeg') {
                    fileName = 'logo.jpg';
                } else if (mimeType === 'image/png') {
                    fileName = 'logo.png';
                } else if (this.imageData?.file_name) {
                    fileName = this.imageData.file_name;
                }

                return new File([blob], fileName, {type: mimeType});
            } catch (error) {
                console.error('Błąd podczas przygotowywania pliku logo:', error);
                throw error;
            }
        },
        isLogoVector() {
            const isBitmapPdf = this.imageData?.custom_properties?.is_bitmap_pdf === true
                || this.imageData?.custom_properties?.is_bitmap_pdf === 1
                || this.imageData?.custom_properties?.is_bitmap_pdf === '1';

            if (isBitmapPdf) {
                return false;
            }

            const fileName = this.colors?.file || this.imageData?.file_name || '';
            const ext = fileName.split('.').pop().toLowerCase();
            return ext === 'svg';
        },
        looksLikeSvg(content) {
            if (!content || typeof content !== 'string') {
                return false;
            }
            return content.slice(0, 2000).toLowerCase().includes('<svg');
        },
        blobToRasterDataUrl(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve({type: 'raster', content: reader.result});
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        async parseLogoResponse(response) {
            if (!response || !response.ok) {
                return null;
            }

            const blob = await response.blob();
            if (!blob || blob.size === 0) {
                return null;
            }

            const mime = (blob.type || response.headers.get('content-type') || '').toLowerCase();
            if (mime.includes('png') || mime.includes('jpeg') || mime.includes('jpg') || mime.includes('webp') || mime.includes('gif')) {
                return this.blobToRasterDataUrl(blob);
            }

            const buffer = await blob.arrayBuffer();
            const bytes = new Uint8Array(buffer.slice(0, 8));
            const isPng = bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47;
            const isJpeg = bytes[0] === 0xff && bytes[1] === 0xd8;
            if (isPng || isJpeg) {
                const rasterBlob = new Blob([buffer], {type: isPng ? 'image/png' : 'image/jpeg'});
                return this.blobToRasterDataUrl(rasterBlob);
            }

            const text = new TextDecoder('utf-8').decode(buffer);
            if (this.looksLikeSvg(text)) {
                return {type: 'svg', content: text};
            }

            return null;
        },
        productionSvgFileCandidates() {
            const names = [];
            const gravFile = this.colors?.grav_logo_file;
            if (gravFile) {
                names.push(gravFile);
            }
            if (this.isEngravingPrintMethod()) {
                const colorFile = this.colors?.file;
                if (colorFile) {
                    const base = colorFile
                        .replace(/-crop(?=\.[^.]+$)/i, '')
                        .replace(/\.[^.]+$/i, '');
                    for (let n = 10; n >= 1; n--) {
                        names.push(`${base}_all_colors_${n}.svg`);
                        names.push(`${base}_engrave_${n}.svg`);
                    }
                }
            }
            const colorFile = this.colors?.file;
            if (colorFile) {
                names.push(colorFile);
                const ext = colorFile.split('.').pop();
                if (ext && ext.toLowerCase() !== 'svg') {
                    names.push(`${colorFile.slice(0, -(ext.length + 1))}.svg`);
                }
            }
            return [...new Set(names.filter(Boolean))];
        },
        async fetchLogoContentForSvg() {
            try {
                for (const fileName of this.productionSvgFileCandidates()) {
                    const response = await fetch(
                        `/api/file?file_name=${encodeURIComponent(fileName)}&uuid=${encodeURIComponent(this.uuid)}&t=${Date.now()}`
                    );
                    const parsed = await this.parseLogoResponse(response);
                    if (parsed) {
                        return parsed;
                    }
                }

                const logoSrc = this.logoConfig.image?.src;
                if (!logoSrc) {
                    return null;
                }

                const response = await fetch(logoSrc);
                return await this.parseLogoResponse(response);
            } catch (error) {
                console.error('Error fetching logo for SVG production:', error);
                return null;
            }
        },
        stageToLocalCoords(stageX, stageY) {
            const border = this.borderConfig;
            const angle = -((border.rotation || 0) * Math.PI) / 180;
            const dx = stageX - border.x;
            const dy = stageY - border.y;
            return {
                x: dx * Math.cos(angle) - dy * Math.sin(angle),
                y: dx * Math.sin(angle) + dy * Math.cos(angle),
            };
        },
        async buildProductionSvg() {
            const border = this.borderConfig;
            const logo = this.logoConfig;
            const text = this.textConfig;
            const borderRotation = border.rotation || 0;

            const pxToMm = (this.printPlace.gbox_settings.scale.dim / this.printPlace.gbox_settings.scale.line) * 10;
            const widthMm = (border.width * pxToMm).toFixed(2);
            const heightMm = (border.height * pxToMm).toFixed(2);

            let logoElement = '';
            if (logo.visible && logo.image) {
                const local = this.stageToLocalCoords(logo.x, logo.y);
                const localRotation = (logo.rotation || 0) - borderRotation;
                const logoData = await this.fetchLogoContentForSvg();

                if (!logoData) {
                    console.warn('Production SVG: failed to fetch logo content from', this.logoConfig.image?.src);
                }

                if (logoData) {
                    if (logoData.type === 'svg') {
                        let svgContent = logoData.content;
                        const viewBoxMatch = svgContent.match(/viewBox=["']([^"']*)["']/);
                        const viewBox = viewBoxMatch ? viewBoxMatch[1] : `0 0 ${logo.width} ${logo.height}`;

                        svgContent = svgContent
                            .replace(/<\?xml[^?]*\?>\s*/g, '')
                            .replace(/<!DOCTYPE[^>]*>\s*/g, '');

                        const innerContent = svgContent
                            .replace(/<svg[^>]*>/, '')
                            .replace(/<\/svg>\s*$/, '');

                        logoElement = `<g transform="translate(${local.x}, ${local.y}) rotate(${localRotation})">` +
                            `<svg width="${logo.width}" height="${logo.height}" viewBox="${viewBox}" overflow="visible">` +
                            innerContent +
                            `</svg></g>`;
                    } else {
                        logoElement = `<image xlink:href="${logoData.content}" ` +
                            `x="0" y="0" ` +
                            `width="${logo.width}" height="${logo.height}" ` +
                            `transform="translate(${local.x}, ${local.y}) rotate(${localRotation})" ` +
                            `preserveAspectRatio="none"/>`;
                    }
                }
            }

            let textElement = '';
            if (text.visible && text.text) {
                const local = this.stageToLocalCoords(text.x, text.y);
                const textNode = this.$refs.text ? this.$refs.text.getNode() : null;
                const stageRotation = (textNode && typeof textNode.rotation === 'function')
                    ? Number(textNode.rotation())
                    : Number(text.rotation || 0);
                const localRotation = stageRotation - borderRotation;
                this.textConfig.rotation = stageRotation;

                const fontStyle = (text.fontStyle || '').includes('italic') ? 'italic' : 'normal';
                const fontWeight = text.fontWeight || 'normal';
                const decoration = text.textDecoration === 'underline' ? 'underline' : 'none';
                const fontSize = parseInt(text.fontSize, 10) || 16;

                const nodeWidth = textNode ? textNode.width() : 0;
                const nodeHeight = textNode ? textNode.height() : 0;

                let anchorOffsetX = 0;
                let anchor = 'start';
                if (text.align === 'center') {
                    anchorOffsetX = nodeWidth / 2;
                    anchor = 'middle';
                } else if (text.align === 'right') {
                    anchorOffsetX = nodeWidth;
                    anchor = 'end';
                }

                const lines = String(text.text).split('\n');
                const lineHeightMultiplier = (textNode && typeof textNode.lineHeight === 'function')
                    ? (textNode.lineHeight() || 1)
                    : (Number(text.lineHeight) || 1);
                const lineHeight = fontSize * lineHeightMultiplier;
                const actualTextHeight = lines.length * lineHeight;

                let verticalOffsetY = 0;
                const vAlign = text.verticalAlign || 'top';
                if (vAlign === 'middle') {
                    verticalOffsetY = (nodeHeight - actualTextHeight) / 2;
                } else if (vAlign === 'bottom') {
                    verticalOffsetY = nodeHeight - actualTextHeight;
                }

                const sampleLine = lines[0] || 'M';
                let ascentOffset = fontSize * 0.72;
                if (textNode && typeof textNode.measureSize === 'function') {
                    const metrics = textNode.measureSize(sampleLine);
                    ascentOffset = metrics.actualBoundingBoxAscent
                        ?? metrics.fontBoundingBoxAscent
                        ?? ascentOffset;
                } else {
                    const ctx = document.createElement('canvas').getContext('2d');
                    ctx.font = `${fontStyle} ${fontWeight} ${fontSize}px ${quoteFontFamily(text.fontFamily || 'Arial')}`;
                    const metrics = ctx.measureText(sampleLine);
                    ascentOffset = metrics.actualBoundingBoxAscent ?? ascentOffset;
                }

                const tspans = lines.map((line, i) => {
                    if (i === 0) {
                        return `<tspan x="${anchorOffsetX}" dy="${ascentOffset}">${this.escapeXml(line)}</tspan>`;
                    }
                    return `<tspan x="${anchorOffsetX}" dy="${lineHeight}">${this.escapeXml(line)}</tspan>`;
                }).join('');

                // Inkscape --export-text-to-path keeps bold/italic glyphs but drops
                // CSS text-decoration. Draw underline as a real <line> so it survives PDF.
                let underlineElements = '';
                if (decoration === 'underline') {
                    const strokeWidth = Math.max(fontSize / 15, 0.5);
                    const fill = text.fill || '#000000';
                    const measureLineWidth = (line) => {
                        if (textNode && typeof textNode.measureSize === 'function') {
                            return Number(textNode.measureSize(line).width) || 0;
                        }
                        const ctx = document.createElement('canvas').getContext('2d');
                        ctx.font = `${fontStyle} ${fontWeight} ${fontSize}px ${quoteFontFamily(text.fontFamily || 'Arial')}`;
                        return ctx.measureText(line).width;
                    };
                    underlineElements = lines.map((line, i) => {
                        const lineWidth = measureLineWidth(line);
                        const baselineY = verticalOffsetY + ascentOffset + i * lineHeight;
                        const y = baselineY + fontSize * 0.12;
                        let x1 = anchorOffsetX;
                        if (anchor === 'middle') {
                            x1 = anchorOffsetX - lineWidth / 2;
                        } else if (anchor === 'end') {
                            x1 = anchorOffsetX - lineWidth;
                        }
                        return `<line x1="${x1}" y1="${y}" x2="${x1 + lineWidth}" y2="${y}" stroke="${fill}" stroke-width="${strokeWidth}" stroke-linecap="butt"/>`;
                    }).join('');
                }

                textElement = `<g transform="translate(${local.x}, ${local.y}) rotate(${localRotation})">` +
                    `<text ` +
                    `x="${anchorOffsetX}" y="${verticalOffsetY}" ` +
                    `font-family="${text.fontFamily || 'Arial'}" ` +
                    `font-size="${fontSize}" ` +
                    `font-weight="${fontWeight}" ` +
                    `font-style="${fontStyle}" ` +
                    `text-decoration="${decoration}" ` +
                    `fill="${text.fill || '#000000'}" ` +
                    `text-anchor="${anchor}"` +
                    `>${tspans}</text>${underlineElements}</g>`;
            }

            return `<?xml version="1.0" encoding="UTF-8"?>` +
                `<svg xmlns="http://www.w3.org/2000/svg" ` +
                `xmlns:xlink="http://www.w3.org/1999/xlink" ` +
                `width="${widthMm}mm" height="${heightMm}mm" ` +
                `viewBox="0 0 ${border.width} ${border.height}">` +
                logoElement +
                textElement +
                `</svg>`;
        },
        escapeXml(str) {
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&apos;');
        },
        async uploadProductionSvg() {
            try {
                await this.$nextTick();
                const svgString = await this.buildProductionSvg();
                const svgBlob = new Blob([svgString], {type: 'image/svg+xml'});

                const formData = new FormData();
                const urlParams = new URLSearchParams(window.location.search);
                formData.append('uuid', this.uuid);
                formData.append('language', urlParams.get('lang') ?? 'pl');
                formData.append('production_svg', svgBlob, 'production.svg');

                const response = await fetch('/api/visualization/production-svg', {
                    method: 'POST',
                    body: formData,
                });

                if (!response.ok) {
                    throw new Error(`Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error uploading production SVG:', error);
            }
        },
        validateLogoRotation(newRotationDegrees) {
            if (!this.logoConfig.visible || !this.$refs.logo || !this.$refs.border) {
                return true;
            }

            const logoNode = this.$refs.logo.getNode();
            const borderNode = this.$refs.border.getNode();
            if (!logoNode || !borderNode) {
                return true;
            }

            const absPos = logoNode.getAbsolutePosition();
            const absScale = logoNode.getAbsoluteScale();
            const widthAbs = logoNode.width() * absScale.x;
            const heightAbs = logoNode.height() * absScale.y;
            const xAbs = absPos.x;
            const yAbs = absPos.y;

            // Simulate rotateAroundCenter: compute the adjusted top-left
            // position that keeps the visual center fixed after rotation.
            const topLeft = {x: -widthAbs / 2, y: -heightAbs / 2};
            const currentRotationRad = this.deg2rad(logoNode.rotation());
            const newRotationRad = this.deg2rad(newRotationDegrees);
            const currentRotated = this.rotatePoint2(topLeft, currentRotationRad);
            const newRotated = this.rotatePoint2(topLeft, newRotationRad);
            const adjustedX = xAbs + (newRotated.x - currentRotated.x);
            const adjustedY = yAbs + (newRotated.y - currentRotated.y);

            let rotatedPoints = calculateRotatedCorners(
                adjustedX,
                adjustedY,
                widthAbs,
                heightAbs,
                newRotationDegrees
            );

            // Pobierz prostokąt graniczny i jego rotację
            const borderRotation = borderNode.rotation();
            let borderRect = borderNode.getClientRect();
            if (borderRotation !== 0) {
                // Tymczasowo zdejmij rotację, aby uzyskać nierotowany clientRect
                borderNode.rotation(0);
                borderRect = borderNode.getClientRect();
                borderNode.rotation(borderRotation);
            }

            // Greenbox w kształcie koła: logo po obrocie musi w całości zmieścić się w okręgu.
            const circle = getGboxCircle(borderNode);
            if (circle) {
                return cornersInsideCircle(rotatedPoints, circle, 0);
            }

            // Gdy obramowanie jest obrócone, przetransformuj punkty logo do układu nierotowanego obramowania
            if (borderRotation !== 0) {
                const borderCenterX = borderRect.x + borderRect.width / 2;
                const borderCenterY = borderRect.y + borderRect.height / 2;

                const transformedPoints = rotatedPoints.map(point =>
                    rotatePoint(borderRect.x, borderRect.y, point.x, point.y, -borderRotation)
                );

                const transformedX = transformedPoints.map(p => p.x);
                const transformedY = transformedPoints.map(p => p.y);
                const transformedBoundingBox = {
                    x1: Math.min(...transformedX),
                    x2: Math.max(...transformedX),
                    y1: Math.min(...transformedY),
                    y2: Math.max(...transformedY),
                };

                const unrotatedBorderRect = {
                    x: borderCenterX - borderRect.width / 2,
                    y: borderCenterY - borderRect.height / 2,
                    width: borderRect.width,
                    height: borderRect.height
                };

                const fits = (
                    transformedBoundingBox.x1 >= unrotatedBorderRect.x &&
                    transformedBoundingBox.x2 <= unrotatedBorderRect.x + unrotatedBorderRect.width &&
                    transformedBoundingBox.y1 >= unrotatedBorderRect.y &&
                    transformedBoundingBox.y2 <= unrotatedBorderRect.y + unrotatedBorderRect.height
                );

                return !!fits;
            } else {
                // Standardowa walidacja dla nierotowanego obramowania
                const xCoords = rotatedPoints.map(p => p.x);
                const yCoords = rotatedPoints.map(p => p.y);
                const boundingBox = {
                    x1: Math.min(...xCoords),
                    x2: Math.max(...xCoords),
                    y1: Math.min(...yCoords),
                    y2: Math.max(...yCoords),
                };

                const fits = (
                    boundingBox.x1 >= borderRect.x &&
                    boundingBox.x2 <= borderRect.x + borderRect.width &&
                    boundingBox.y1 >= borderRect.y &&
                    boundingBox.y2 <= borderRect.y + borderRect.height
                );

                return !!fits;
            }
        },
        fitLogoToRotation(newRotationDegrees) {
            // Aplikuje żądaną rotację. Gdy logo mieści się w gboxie – obraca wokół
            // środka bez zmiany rozmiaru. Gdy nie – proporcjonalnie zmniejsza do maksimum
            // i centruje w obramowaniu. Zwraca true, jeśli udało się dopasować.
            if (!this.logoConfig.visible || !this.$refs.logo || !this.$refs.border) {
                return false;
            }

            const currentWidth = this.logoConfig.width;
            const currentHeight = this.logoConfig.height;
            if (!(currentWidth > 0) || !(currentHeight > 0)) {
                return false;
            }

            const borderRotation = this.borderConfig.rotation || 0;
            const relRad = this.deg2rad(newRotationDegrees - borderRotation);
            const absCos = Math.abs(Math.cos(relRad));
            const absSin = Math.abs(Math.sin(relRad));

            const rotatedWidth = currentWidth * absCos + currentHeight * absSin;
            const rotatedHeight = currentWidth * absSin + currentHeight * absCos;

            let scaleFactor;
            if (this.borderConfig.gboxShape === 'circle') {
                const radius = Math.max(this.borderConfig.width / 2, 1);
                const halfDiagonal = Math.hypot(currentWidth / 2, currentHeight / 2);
                scaleFactor = radius / halfDiagonal;
            } else {
                const availWidth = Math.max(this.borderConfig.width, 1);
                const availHeight = Math.max(this.borderConfig.height, 1);
                scaleFactor = Math.min(availWidth / rotatedWidth, availHeight / rotatedHeight);
            }

            if (!isFinite(scaleFactor) || scaleFactor <= 0) {
                return false;
            }
            scaleFactor = Math.min(scaleFactor, 1);

            if (scaleFactor >= 1 - 1e-4) {
                // Rotacja możliwa przy aktualnym rozmiarze – obracamy wokół środka
                const topLeft = {x: -currentWidth / 2, y: -currentHeight / 2};
                const currentRotRad = this.deg2rad(this.logoConfig.rotation || 0);
                const newRotRad = this.deg2rad(newRotationDegrees);
                const currentRotated = this.rotatePoint2(topLeft, currentRotRad);
                const newRotated = this.rotatePoint2(topLeft, newRotRad);

                this.logoConfig.rotation = newRotationDegrees;
                this.logoConfig.x = this.logoConfig.x + (newRotated.x - currentRotated.x);
                this.logoConfig.y = this.logoConfig.y + (newRotated.y - currentRotated.y);

                // Porównanie samych wymiarów nie uwzględnia pozycji (np. logo dosunięte
                // dłuższym bokiem do krawędzi i obrót o 90°). Dociągamy do wewnętrznej
                // krawędzi gboxa, tak jak przy przeciąganiu.
                // shapeDragBoundFunc zakłada scale stage = 1 – chwilowo resetujemy transform
                // sceny (bez zmiany this.scale / zoomStage, żeby nie przesuwać canvasu).
                const stage = this.$refs.stage.getNode();
                const savedStageScale = {x: stage.scaleX(), y: stage.scaleY()};
                const savedStagePosition = {x: stage.x(), y: stage.y()};

                if (this.initialStageState) {
                    stage.scale({...this.initialStageState.scale});
                    stage.position({...this.initialStageState.position});
                } else {
                    stage.scale({x: 1, y: 1});
                    stage.position({x: 0, y: 0});
                }
                stage.batchDraw();

                const logoNode = this.$refs.logo.getNode();
                logoNode.x(this.logoConfig.x);
                logoNode.y(this.logoConfig.y);
                logoNode.rotation(this.logoConfig.rotation);

                const constrained = shapeDragBoundFunc.call(logoNode, {
                    x: this.logoConfig.x,
                    y: this.logoConfig.y,
                });
                this.logoConfig.x = constrained.x;
                this.logoConfig.y = constrained.y;

                stage.scale(savedStageScale);
                stage.position(savedStagePosition);
                stage.batchDraw();
            } else {
                // Rotacja niemożliwa przy aktualnym rozmiarze – zmniejszamy i centrujemy
                const newWidth = currentWidth * scaleFactor;
                const newHeight = currentHeight * scaleFactor;

                const borderHalf = this.rotatePoint2(
                    {x: this.borderConfig.width / 2, y: this.borderConfig.height / 2},
                    this.deg2rad(borderRotation)
                );
                const borderCenterX = this.borderConfig.x + borderHalf.x;
                const borderCenterY = this.borderConfig.y + borderHalf.y;

                const logoHalf = this.rotatePoint2(
                    {x: newWidth / 2, y: newHeight / 2},
                    this.deg2rad(newRotationDegrees)
                );

                this.logoConfig.width = newWidth;
                this.logoConfig.height = newHeight;
                this.logoConfig.rotation = newRotationDegrees;
                this.logoConfig.x = borderCenterX - logoHalf.x;
                this.logoConfig.y = borderCenterY - logoHalf.y;

                const logoNode = this.$refs.logo.getNode();
                if (logoNode) {
                    logoNode.width(newWidth);
                    logoNode.height(newHeight);
                    logoNode.rotation(newRotationDegrees);
                    logoNode.x(this.logoConfig.x);
                    logoNode.y(this.logoConfig.y);
                }
            }

            this.$nextTick(() => {
                const logoNode = this.$refs.logo ? this.$refs.logo.getNode() : null;
                if (logoNode && logoNode.getLayer()) {
                    logoNode.getLayer().batchDraw();
                }

                this.emitLogoAreaStatus();

                this.$emit('resize:logo', {
                    "scale": this.printPlace.gbox_settings.scale,
                    "config": this.logoConfig
                });

                this.addHistory('logo');

                if (!(this.confirmed === true && this.editAfterSave)) {
                    this.handleSaveVisualizationAndConfirm();
                }
            });

            return true;
        },
        downloadURI(uri, name) {
            const link = document.createElement('a');
            link.download = name;
            link.href = uri;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        changeVariant(variant) {

            if (variant === this.pickedVariant) {
                return;
            }

            let chosenVariant = null;

            if (variant === this.printPlace.product_erp_code) {
                chosenVariant = {...this.printPlace}
            } else {
                chosenVariant = this.variants.find(v => v.product_erp_code === variant)
            }

            if (chosenVariant !== null) {
                const image = new window.Image();

                let media = chosenVariant?.media[0];

                if (media) {
                    image.src = media.original_url;
                } else {
                    image.src = '/img/missing.jpg'
                }

                image.onload = () => {
                    // Ustawiamy obraz
                    this.image = image;

                    // Pobieramy naturalne wymiary obrazu
                    const naturalWidth = image.naturalWidth;
                    const naturalHeight = image.naturalHeight;

                    // Wymiary sceny
                    const stageWidth = this.stageConfig.width;
                    const stageHeight = this.stageConfig.height;

                    // Obliczamy skalę, aby dopasować obraz do sceny zachowując proporcje
                    const scale = Math.min(stageWidth / naturalWidth, stageHeight / naturalHeight);

                    // Obliczamy nowe wymiary obrazu
                    const imageWidth = naturalWidth * scale;
                    const imageHeight = naturalHeight * scale;

                    // Centrujemy obraz na scenie
                    const x = (stageWidth - imageWidth) / 2;
                    const y = (stageHeight - imageHeight) / 2;

                    // Aktualizujemy konfigurację obrazu
                    this.imageConfig = {
                        image: image,
                        x: x,
                        y: y,
                        width: imageWidth,
                        height: imageHeight,
                        name: 'backgroundImage', // Upewnij się, że nazwa jest dodana
                    };

                    this.pickedVariant = variant;
                };
            }


        }, rotatePoint2({x, y}, rad) {
            const rcos = Math.cos(rad);
            const rsin = Math.sin(rad);
            return {x: x * rcos - y * rsin, y: y * rcos + x * rsin};
        },
        rotateAroundCenter(node, rotation) {
            //current rotation origin (0, 0) relative to desired origin - center (node.width()/2, node.height()/2)
            const topLeft = {x: -node.width() / 2, y: -node.height() / 2};
            const current = this.rotatePoint2(topLeft, this.deg2rad(node.rotation()));
            const rotated = this.rotatePoint2(topLeft, this.deg2rad(rotation));
            const dx = rotated.x - current.x,
                dy = rotated.y - current.y;

            node.rotation(rotation);
            node.x(node.x() + dx);
            node.y(node.y() + dy);
        }

    }
}


function shapeDragBoundFunc(pos) {
    const shape = this;
    const stage = shape.getStage();
    const borderNode = stage.findOne('.gboxBorder');

    if (!borderNode) {
        return pos;
    }

    const borderRotation = borderNode.rotation();
    let borderRect = borderNode.getClientRect();
    if (borderRotation !== 0) {
        borderNode.rotation(0);
        borderRect = borderNode.getClientRect();
        borderNode.rotation(borderRotation);
    }

    const origX = shape.x();
    const origY = shape.y();
    shape.x(pos.x);
    shape.y(pos.y);
    const shapeRect = shape.getClientRect();
    const shapeRectPos = shape.getAbsolutePosition(stage);
    shapeRect.x = shapeRectPos.x;
    shapeRect.y = shapeRectPos.y;
    shape.x(origX);
    shape.y(origY);

    let newX = pos.x;
    let newY = pos.y;

    // Calculate rotated corners of the shape
    let rotatedRect = calculateRotatedCorners(shapeRect.x, shapeRect.y, shape.width() * shape.getAbsoluteScale().x, shape.height() * shape.getAbsoluteScale().y, shape.rotation());

    // Update the rotated points visualization
    const debugRotatedRectPoints = stage.findOne('.debugRotatedRectPoints');
    if (debugRotatedRectPoints) {
        const flatPoints = rotatedRect.reduce((arr, point) => [...arr, point.x, point.y], []);
        debugRotatedRectPoints.setAttrs({
            points: flatPoints,
            // visible: true
        });
    }

    // Greenbox w kształcie koła: dociągamy logo tak, aby wszystkie jego
    // (obrócone) narożniki mieściły się w okręgu – pełen zakres ruchu po kole.
    const circle = getGboxCircle(borderNode);
    if (circle) {
        const {dx, dy} = clampCornersToCircle(rotatedRect, circle);
        return {
            x: pos.x + dx,
            y: pos.y + dy,
        };
    }

    // If border is rotated, transform shape points to border's coordinate system
    if (borderRotation !== 0) {
        const borderCenterX = borderRect.x + borderRect.width / 2;
        const borderCenterY = borderRect.y + borderRect.height / 2;

        // Transform shape corners to border's unrotated coordinate system
        rotatedRect = rotatedRect.map(point =>
            rotatePoint(borderRect.x, borderRect.y, point.x, point.y, -borderRotation)
        );

        // Use unrotated border rectangle for boundary checks
        const unrotatedBorderRect = {
            x: borderCenterX - borderRect.width / 2,
            y: borderCenterY - borderRect.height / 2,
            width: borderRect.width,
            height: borderRect.height
        };

        let xCoords = rotatedRect.map(p => p.x);
        let yCoords = rotatedRect.map(p => p.y);

        const debugRotatedRect = stage.findOne('.debugRotatedRect');
        if (debugRotatedRect) {
            debugRotatedRect.setAttrs({
                x: Math.min(...xCoords),
                y: Math.min(...yCoords),
                width: Math.max(...xCoords) - Math.min(...xCoords),
                height: Math.max(...yCoords) - Math.min(...yCoords),
                // visible: true
            });
        }

        let boundingBox = {
            x1: Math.min(...xCoords),
            x2: Math.max(...xCoords),
            y1: Math.min(...yCoords),
            y2: Math.max(...yCoords),
        };

        let deltaX = 0;
        let deltaY = 0;

        if (boundingBox.x1 < unrotatedBorderRect.x) {
            deltaX += unrotatedBorderRect.x - boundingBox.x1;
        }
        if (boundingBox.y1 < unrotatedBorderRect.y) {
            deltaY += unrotatedBorderRect.y - boundingBox.y1;
        }
        if (boundingBox.x2 > unrotatedBorderRect.x + unrotatedBorderRect.width) {
            deltaX -= boundingBox.x2 - (unrotatedBorderRect.x + unrotatedBorderRect.width);
        }
        if (boundingBox.y2 > unrotatedBorderRect.y + unrotatedBorderRect.height) {
            deltaY -= boundingBox.y2 - (unrotatedBorderRect.y + unrotatedBorderRect.height);
        }

        const debugUnrotatedRect = stage.findOne('.debugUnrotatedRect');
        if (debugUnrotatedRect) {
            debugUnrotatedRect.setAttrs({
                x: unrotatedBorderRect.x,
                y: unrotatedBorderRect.y,
                width: unrotatedBorderRect.width,
                height: unrotatedBorderRect.height,
                // visible: true
            });
        }

        // Transform the delta back to the original coordinate system
        const rotatedDelta = rotatePoint(0, 0, deltaX, deltaY, borderRotation);
        newX += rotatedDelta.x;
        newY += rotatedDelta.y;
    } else {
        // Original logic for non-rotated borders
        let xCoords = rotatedRect.map(p => p.x);
        let yCoords = rotatedRect.map(p => p.y);

        let boundingBox = {
            x1: Math.min(...xCoords),
            x2: Math.max(...xCoords),
            y1: Math.min(...yCoords),
            y2: Math.max(...yCoords),
        };

        if (boundingBox.x1 < borderRect.x) {
            newX += borderRect.x - boundingBox.x1;
        }
        if (boundingBox.y1 < borderRect.y) {
            newY += borderRect.y - boundingBox.y1;
        }
        if (boundingBox.x2 > borderRect.x + borderRect.width) {
            newX -= boundingBox.x2 - (borderRect.x + borderRect.width);
        }
        if (boundingBox.y2 > borderRect.y + borderRect.height) {
            newY -= boundingBox.y2 - (borderRect.y + borderRect.height);
        }
    }

    return {
        x: newX,
        y: newY,
    };
}

function checkIfInBorderBox(pos) {
    const shape = this;
    const stage = shape.getStage();
    const borderNode = stage.findOne('.gboxBorder');

    if (!borderNode) {
        return pos;
    }

    const borderRotation = borderNode.rotation();
    let borderRect = borderNode.getClientRect();
    if (borderRotation !== 0) {
        borderNode.rotation(0);
        borderRect = borderNode.getClientRect();
        borderNode.rotation(borderRotation);
    }

    // Update the border rect visualization
    const debugBorderRect = stage.findOne('.debugBorderRect');
    if (debugBorderRect) {
        debugBorderRect.setAttrs({
            x: borderRect.x,
            y: borderRect.y,
            width: borderRect.width,
            height: borderRect.height,
            // visible: true
        });
    }

    const origX = shape.x();
    const origY = shape.y();
    shape.x(pos.x);
    shape.y(pos.y);
    const shapeRect = shape.getClientRect();
    const shapeRectPos = shape.getAbsolutePosition(stage);
    shapeRect.x = shapeRectPos.x;
    shapeRect.y = shapeRectPos.y;
    shape.x(origX);
    shape.y(origY);

    // Calculate rotated corners of the shape
    let rotatedRect = calculateRotatedCorners(shapeRect.x, shapeRect.y, shape.width() * shape.getAbsoluteScale().x, shape.height() * shape.getAbsoluteScale().y, shape.rotation());

    // Update the rotated points visualization
    const debugRotatedRectPoints = stage.findOne('.debugRotatedRectPoints');
    if (debugRotatedRectPoints) {
        const flatPoints = rotatedRect.reduce((arr, point) => [...arr, point.x, point.y], []);
        debugRotatedRectPoints.setAttrs({
            points: flatPoints,
            // visible: true
        });
    }

    // Greenbox w kształcie koła: sprawdzamy, czy wszystkie narożniki mieszczą się w okręgu.
    const circle = getGboxCircle(borderNode);
    if (circle) {
        return cornersInsideCircle(rotatedRect, circle);
    }

    // If border is rotated, transform shape points to border's coordinate system
    if (borderRotation !== 0) {
        const borderCenterX = borderRect.x + borderRect.width / 2;
        const borderCenterY = borderRect.y + borderRect.height / 2;

        // Transform shape corners to border's unrotated coordinate system
        rotatedRect = rotatedRect.map(point =>
            rotatePoint(borderRect.x, borderRect.y, point.x, point.y, -borderRotation)
        );

        // Use unrotated border rectangle for boundary checks
        const unrotatedBorderRect = {
            x: borderCenterX - borderRect.width / 2,
            y: borderCenterY - borderRect.height / 2,
            width: borderRect.width,
            height: borderRect.height
        };

        let xCoords = rotatedRect.map(p => p.x);
        let yCoords = rotatedRect.map(p => p.y);

        const debugRotatedRect = stage.findOne('.debugRotatedRect');
        if (debugRotatedRect) {
            debugRotatedRect.setAttrs({
                x: Math.min(...xCoords),
                y: Math.min(...yCoords),
                width: Math.max(...xCoords) - Math.min(...xCoords),
                height: Math.max(...yCoords) - Math.min(...yCoords),
                // visible: true
            });
        }

        let boundingBox = {
            x1: Math.min(...xCoords),
            x2: Math.max(...xCoords),
            y1: Math.min(...yCoords),
            y2: Math.max(...yCoords),
        };

        const edgeEps = 0.15;
        if (boundingBox.x1 < unrotatedBorderRect.x - edgeEps) {
            return false;
        }
        if (boundingBox.y1 < unrotatedBorderRect.y - edgeEps) {
            return false;
        }
        if (boundingBox.x2 > unrotatedBorderRect.x + unrotatedBorderRect.width + edgeEps) {
            return false;
        }
        if (boundingBox.y2 > unrotatedBorderRect.y + unrotatedBorderRect.height + edgeEps) {
            return false;
        }

        const debugUnrotatedRect = stage.findOne('.debugUnrotatedRect');
        if (debugUnrotatedRect) {
            debugUnrotatedRect.setAttrs({
                x: unrotatedBorderRect.x,
                y: unrotatedBorderRect.y,
                width: unrotatedBorderRect.width,
                height: unrotatedBorderRect.height,
                // visible: true
            });
        }
    } else {
        // Original logic for non-rotated borders
        let xCoords = rotatedRect.map(p => p.x);
        let yCoords = rotatedRect.map(p => p.y);

        let boundingBox = {
            x1: Math.min(...xCoords),
            x2: Math.max(...xCoords),
            y1: Math.min(...yCoords),
            y2: Math.max(...yCoords),
        };

        const edgeEps = 0.15;
        if (boundingBox.x1 < borderRect.x - edgeEps) {
            return false;
        }
        if (boundingBox.y1 < borderRect.y - edgeEps) {
            return false;
        }
        if (boundingBox.x2 > borderRect.x + borderRect.width + edgeEps) {
            return false;
        }
        if (boundingBox.y2 > borderRect.y + borderRect.height + edgeEps) {
            return false;
        }
    }

    return true;
}

// Zwraca geometrię okrągłego greenboxa ({cx, cy, radius}) na podstawie węzła
// obramowania, albo null, jeśli aktualny greenbox nie jest kołem.
function getGboxCircle(borderNode) {
    if (!borderNode || borderNode.getAttr('gboxShape') !== 'circle') {
        return null;
    }

    const borderRotation = borderNode.rotation();
    let borderRect = borderNode.getClientRect();
    if (borderRotation !== 0) {
        borderNode.rotation(0);
        borderRect = borderNode.getClientRect();
        borderNode.rotation(borderRotation);
    }

    return {
        cx: borderRect.x + borderRect.width / 2,
        cy: borderRect.y + borderRect.height / 2,
        radius: Math.min(borderRect.width, borderRect.height) / 2,
    };
}

// Czy wszystkie narożniki (obrócony prostokąt logo) mieszczą się w okręgu?
// Dla figury wypukłej wystarczy sprawdzić jej wierzchołki.
function cornersInsideCircle(corners, circle, tolerance = 0.5) {
    return corners.every(corner =>
        Math.hypot(corner.x - circle.cx, corner.y - circle.cy) <= circle.radius + tolerance
    );
}

// Wyznacza minimalne przesunięcie {dx, dy}, po którym wszystkie narożniki
// znajdą się wewnątrz okręgu. Wykorzystuje rzutowanie na zbiory wypukłe
// (cykliczne dociąganie wystających narożników do brzegu okręgu).
// Gdy logo jest większe od okręgu, w ostateczności centruje je w okręgu.
function clampCornersToCircle(corners, circle) {
    let dx = 0;
    let dy = 0;

    for (let iter = 0; iter < 24; iter++) {
        let maxOverflow = 0;

        for (const corner of corners) {
            const px = corner.x + dx;
            const py = corner.y + dy;
            const vx = px - circle.cx;
            const vy = py - circle.cy;
            const dist = Math.hypot(vx, vy);

            if (dist > circle.radius) {
                maxOverflow = Math.max(maxOverflow, dist - circle.radius);
                const scale = circle.radius / dist;
                dx += circle.cx + vx * scale - px;
                dy += circle.cy + vy * scale - py;
            }
        }

        if (maxOverflow < 0.01) {
            return {dx, dy};
        }
    }

    let centroidX = 0;
    let centroidY = 0;
    for (const corner of corners) {
        centroidX += corner.x;
        centroidY += corner.y;
    }
    centroidX /= corners.length;
    centroidY /= corners.length;

    return {dx: circle.cx - centroidX, dy: circle.cy - centroidY};
}

function calculateRotatedCorners(x, y, width, height, angle) {
    let centerX = x;
    let centerY = y;

    const corners = [
        {x: x, y: y},
        {x: x + width, y: y},
        {x: x + width, y: y + height},
        {x: x, y: y + height},
    ];

    return corners.map(corner =>
        rotatePoint(centerX, centerY, corner.x, corner.y, angle)
    );
}

function rotatePoint(cx, cy, x, y, angle) {
    return rotatePointRad(cx, cy, x, y, angle * (Math.PI / 180));
}

function rotatePointRad(cx, cy, x, y, theta) {
    const cos = Math.cos(theta);
    const sin = Math.sin(theta);
    const rotatedX = (cos * (x - cx)) - (sin * (y - cy)) + cx;
    const rotatedY = (cos * (y - cy)) + (sin * (x - cx)) + cy;

    return {x: rotatedX, y: rotatedY};
}
</script>
<style scoped>
@import url('https://axpol2.2clicks.pl/template/axpol/prod/css/theme/product_color_definitions.css');
</style>
